import React from "react";
import {
  Card,
  CardContent,
  Typography,
  LinearProgress,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Divider,
  Chip,
  IconButton,
  Tooltip
} from "@material-ui/core";
                      import {
                        Save as SaveIcon,
                        Email as EmailIcon,
                        Warning as WarningIcon,
                        Info as InfoIcon,
                        CheckCircle as CheckCircleIcon,
                        Error as ErrorIcon
                      } from "@material-ui/icons";
import styled from "styled-components";
import moment from "moment";
import moment_tz from 'moment-timezone';
import { connect } from "react-redux";
import { showNotification } from "react-admin";
import { createStyledNotification } from "../../hooks/useNotificationWithColors";
import useCustomNotifications from "../../hooks/useCustomNotifications";
import NotificationContainer from "../NotificationContainer";
import dataProviderFactory from "../../dataProvider";
import { GET_ONE, GET_LIST, UPDATE } from "react-admin";
import {
  map,
  head,
  filter,
  prop,
  propEq,
  find,
  isNil,
  path,
  sum,
  allPass,
  isEmpty
} from "ramda";
//no usar esta funcion, no es necesaria
//import { debugCostCalculation } from "../../utils/tourCostValidator";
import AddSuplementCharge from "../addSuplementCharge";
import ToursRefactoredService from "../../services/ToursRefactoredService";
import ClientDocumentsModal from "../ClientDocumentsModal";
import { documentTarget } from "../../utils/agencyRiderDocuments";
import ProfileCompleteMark from "../profileCompleteMark";
import {
  normalizeInsuranceId,
  isPaidInsurance,
  resolveApplicableInsuranceId,
  insuranceLabel,
  insuranceSelectChoices,
  dailyInsurancePriceFromList,
  INSURANCE_REGULAR,
} from "../../util/rentalInsurance";

// Styled Components
const MainContainer = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px;
  background: #f5f5f5;
  
`;

const LeftPanel = styled(Card)`
  flex: 2;
  max-width: 70%;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const RightPanel = styled(Card)`
  flex: 1;
  max-width: 30%;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 24px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionTitle = styled(Typography)`
  color: #ff9800;
  font-weight: 600;
  margin-bottom: 16px;
  border-bottom: 2px solid #ff9800;
  padding-bottom: 8px;
`;

const FormSection = styled.div`
  margin-bottom: 5px;
  padding: 12px;
  border-radius: 8px;
  background: #fafafa;
`;

const OptionGrid = styled(Grid)`
  margin-bottom: 16px;
`;

const PriceDisplay = styled.div`
  background:rgb(249, 249, 249);
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
  /*border-left: 4px solid #ff9800;*/
`;

const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
`;

const SummaryLabel = styled.span`
  font-weight: 500;
  color: #ff9800;
`;

const SummaryValue = styled.span`
  font-weight: 500;
  color: #000000;
`;

const StyledSelect = styled(Select)`
  width: 100%;
  margin-bottom: 16px;
`;

const ErrorText = styled.div`
  color: #f44336;
  font-size: 0.75rem;
  margin-top: 4px;
`;

const SuccessChip = styled(Chip)`
  background-color: #4caf50;
  color: white;
  margin: 4px;
`;

const WarningChip = styled(Chip)`
  background-color: #ff9800;
  color: white;
  margin: 4px;
`;

const ActionButton = styled(Button)`
  margin: 8px;
`;

const CustomAlert = styled.div`
  padding: 12px 16px;
  margin: 8px 0;
  border-radius: 4px;
  border-left: 4px solid;
  
  &.error {
    background-color: #ffebee;
    color: #c62828;
    border-left-color: #f44336;
  }
  
  &.warning {
    background-color: #fff3e0;
    color: #ef6c00;
    border-left-color: #ff9800;
  }
  
  &.info {
    background-color: #e3f2fd;
    color: #1565c0;
    border-left-color: #2196f3;
  }
  
  &.success {
    background-color: #e8f5e8;
    color: #2e7d32;
    border-left-color: #4caf50;
  }
`;

class TourProcessingEnhanced extends React.Component {
  state = {
    // Data loading states
    loading: true,
    error: null,
    
    // Tour data
    rental: null,
    models: [],
    vehicles: [],
    gpsDevices: [],
    locations: [],
    tourPrices: [],
    gpsPrices: [],
    insurancePrices: [],
    
    // Form values
    vehicle_model_1: 0,
    vehicle_model_2: 0,
    vehicleId: 0,
    gpsDeviceId: 0,
    priceDate: null,
    
    // Options
    r_gps: false,
    r_insurance: false,
    r_insurance_id: INSURANCE_REGULAR,
    r_cancel_insurance: false,
    r_single: false,
    r_double: true,
    low_seat: false,
    
    // Pricing
    value_to_charge: 0,
    valueToChargeConfirmed: 0,
    discount: 0,
    rewards: 0,
    clientRewards: 0,
    originalClientRewards: 0, // ✅ VALOR ORIGINAL DE REWARDS DISPONIBLES
    model1Price: 0,
    model2Price: 0,
    cancelInsuranceValue: 0,
    cancelInsurancePercentage: 0,
    
    // Valor confirmado que no debe cambiar
    confirmedValueToCharge: 0,
    isValueConfirmed: false,
    
    // NUEVA VARIABLE: Valor total calculado (sin descuentos de charges)
    currentValueToCharge: 0,
    
    // ✅ NUEVO: Guardar el valor inicial del displayValueToCharge para mostrarlo en el título
    initialDisplayValueToCharge: 0,
    
    // Variables para mostrar en el UI
    rentalTotal1: 0,
    rentalTotal2: 0,
    
    // Other
    chargeTypeId: "2",
    imt_comment: "",
    comments: "",
    noConfirmationEmail: false,
    checkedF: false,
    customValueEnabled: false,
    customValueToCharge: 0,
    // ✅ NUEVO: Guardar el valor personalizado como string para permitir escritura parcial
    customValueToChargeString: "",
    
    // UI states
    isOnSubmit: false,
    r_insurance_disabled: false,
    r_gps_disabled: false,
    
    // Notifications
    notifications: {
      gps: false,
      vip: false,
      single: false,
      seguroCancel: false
    },
    // CORRECCIÓN: Agregar variables de notificación como en el componente original
    notifiGps: false,
    notifiSingle: false,
    notifiVip: false,
    notifiSeguroCancel: false,
    
    // Campos adicionales para tours ya procesados
    isPendingTour: true,
    imt_commentN: "", 
    extra_comments: "",
    r_documentacion: false,
    clientDocumentsModalOpen: false,
    chargeSuplement: 0,
    refund_value: 0,
    chargeId: 0,
    
    // Opciones adicionales para tours procesados
    partial: 0,
    resend: false,
    sendFinalConfirmation: false,
    valid_charge: false,
    form_error: false,
    valueAvalaible: 0,
    
    // Campos de comentarios adicionales
    invoice_comments: "",
    
    // Campos adicionales para el cálculo detallado de precios
    effectiveDays: 0,
    pricingBreakdown: {
      tour_total: 0,
      vehicle_model: 0,
      vehicle_model_2: 0,
      single_room: 0,
      gps_total: 0,
      vip_insurance: 0,
      cancel_insurance: 0,
      low_seat: 0,
      passenger_price: 0,
      pending_supplements: 0,
      discount: 0,
      rewards: 0,
      subtotal: 0,
      final_total: 0,
      subtotal2: 0,
      final_total2: 0
    },
    valueToChargeCalculatedByUpdatePricing: false
  };

  // Static counter to track getVehicles calls
  static getVehiclesCallCount = 0;

  // API Methods (same as original)
  async getGpsDevices() {
    const { rental } = this.state;
    if (!rental) { 
      return { data: [] };
    }

    // Si no hay booking data, retornar lista vacía
    if (!rental.booking || !rental.booking.tour_id) { 
      return { data: [] };
    }
    const dataProvider = await dataProviderFactory("rest");
    
    // Primero obtener todos los GPS disponibles para el tour
    const responseGps = await dataProvider(GET_LIST, "gps_devices", {
      filter: {
        tour_id: rental.booking.tour_id,
        availability: true,
      },
      pagination: { page: 1, perPage: 99999 },
      sort: { field: "order", order: "ASC" },
    });
    
    // Si hay un GPS seleccionado en el rental, verificar si está en la lista
    if (rental.device && rental.device.length > 0) {
      const selectedGpsId = rental.device[0].id;
      const gpsExists = responseGps.data.some(gps => gps.id === selectedGpsId);
      
      // Si no existe en la lista de GPS disponibles, obtener todos los GPS para incluirlo
      if (!gpsExists) { 
        const allGpsResponse = await dataProvider(GET_LIST, "gps_devices", {
          filter: {
            availability: true,
          },
          pagination: { page: 1, perPage: 99999 },
          sort: { field: "order", order: "ASC" },
        });
        
        // Combinar los GPS disponibles del tour con el GPS seleccionado
        const combinedGps = [...responseGps.data];
        const selectedGps = allGpsResponse.data.find(gps => gps.id === selectedGpsId);
        if (selectedGps) {
          combinedGps.push(selectedGps);
        }
        
        return { data: combinedGps };
      }
    }
    
    return responseGps;
  }

  async getAvailableRewards(id) {
    const dataProvider = await dataProviderFactory("rest");
    const client = await dataProvider(GET_ONE, "clients", { id });
    return path(["data", "availableRewards"], client) || 0;
  }

  async gpsPrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    return await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "gps_device",
        for_date: date,
      },
      pagination: { page: 1, perPage: 99999 },
      sort: { field: "start_date", order: "DESC" },
    });
  }

  async getTourPrices(tourId, date) {
    const dataProvider = await dataProviderFactory("rest");
    return await dataProvider(GET_LIST, "prices", {
      filter: {
        for_date: date,
        for_tour_id: tourId,
      },
      pagination: { page: 1, perPage: 99999 },
      sort: {}
    });
  }

  async insurancePrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    return await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "insurance",
        for_date: date,
      },
      pagination: { page: 1, perPage: 99999 },
      sort: { field: "start_date", order: "DESC" },
    });
  }

  async getVehiclesWithModel(vehicleModelId, rentalOverride = null) {
    try {
      const rental = rentalOverride != null ? rentalOverride : this.state.rental;
      const isPendingTour = rentalOverride != null ? false : this.state.isPendingTour;

      if (!rental || !vehicleModelId) {
        return { data: [] };
      }

      if (!rental.booking || !rental.booking.tour_id) {
        return { data: [] };
      }

      const dataProvider = await dataProviderFactory("rest");
      
      // NUEVA LÓGICA: Filtrar vehículos basándose en el modelo seleccionado
      const filterParams = {
        availability: true,
        tour_id: rental.booking.tour_id,
        vehicle_model_id: vehicleModelId // Filtrar por el modelo seleccionado
      };
 
      const responseVehicles = await dataProvider(GET_LIST, "vehicles", {
        filter: filterParams,
        pagination: { page: 1, perPage: 99999 },
       // sort: { field: "order", order: "ASC" }
      }); 

      // Para tours PROCESADOS: priorizar selected_vehicle_from_items y agregar a la lista si no está
      if (!isPendingTour) {
        const fromItems = rental.selected_vehicle_from_items;
        const hasVehicle = rental.vehicle && Array.isArray(rental.vehicle) && rental.vehicle.length > 0;
        const selectedVehicle = fromItems || (hasVehicle ? head(rental.vehicle) : null);
        if (selectedVehicle && parseInt(selectedVehicle.vehicle_model_id) === parseInt(vehicleModelId)) {
          const vehicleExists = responseVehicles.data.some(v => Number(v.id) === Number(selectedVehicle.id));
          if (!vehicleExists) {
            try {
              // Agregar el vehículo seleccionado a la lista
              const vehicleToAdd = {
                created_at: selectedVehicle.created_at,
                date_2: rental.date_2 || "",
                express_invoice_id: null,
                express_invoice_url: null,
                financing: 0,
                financing_details: "",
                id: selectedVehicle.id,
                insurance_date: null,
                insurance_policy: null,
                insurance_status_id: null,
                item_id: selectedVehicle.id,
                licence_plate: selectedVehicle.licence_plate,
                location_id_2: 0,
                location_name: 0,
                low: 0,
                number_rentals: 0,
                purchase_date: null,
                purchase_price: 0,
                purchased_from: 0,
                renting: selectedVehicle.renting || false,
                retirement_date: null,
                sale_date: null,
                sale_price: 0,
                sold_to: null,
                updated_at: selectedVehicle.updated_at,
                vechicle_chassis: selectedVehicle.vechicle_chassis,
                vehicle_color: selectedVehicle.vehicle_color,
                vehicle_mileage: selectedVehicle.vehicle_mileage,
                vehicle_model_id: selectedVehicle.vehicle_model_id,
                vehicle_options: selectedVehicle.vehicle_options,
                vehicle_status_id: selectedVehicle.vehicle_status_id,
                vehicle_year: selectedVehicle.vehicle_year
              };
              responseVehicles.data.push(vehicleToAdd);
            } catch (pushError) {
             }
          }
        }
      }

      return responseVehicles;
    } catch (error) {
       return { data: [] };
    }
  }

  async getVehicles() {
    try {
      const { rental, vehicle_model_1, isPendingTour } = this.state;
      
      if (!rental || !vehicle_model_1) {
 
        return { data: [] };
      }

      // Si no hay booking data, retornar lista vacía
      if (!rental.booking || !rental.booking.tour_id) { 
        return { data: [] };
      }
      
      const dataProvider = await dataProviderFactory("rest");
      
      // NUEVA LÓGICA: Filtrar vehículos basándose en el modelo seleccionado
      const filterParams = {
        availability: true,
        tour_id: rental.booking.tour_id,
        vehicle_model_id: vehicle_model_1 // Filtrar por el modelo seleccionado
      };
       
      const responseVehicles = await dataProvider(GET_LIST, "vehicles", {
        filter: filterParams,
        pagination: { page: 1, perPage: 99999 },
        sort: { field: "order", order: "ASC" }
      });
 

      // Para tours PROCESADOS: priorizar selected_vehicle_from_items y agregar a la lista si no está
      if (!isPendingTour) {
        const fromItems = rental.selected_vehicle_from_items;
        const hasVehicle = rental.vehicle && Array.isArray(rental.vehicle) && rental.vehicle.length > 0;
        const selectedVehicle = fromItems || (hasVehicle ? head(rental.vehicle) : null);
        if (selectedVehicle && parseInt(selectedVehicle.vehicle_model_id) === parseInt(vehicle_model_1)) {
          const vehicleExists = responseVehicles.data.some(v => Number(v.id) === Number(selectedVehicle.id));
          if (!vehicleExists) {
            try {
              const vehicleToAdd = {
                created_at: selectedVehicle.created_at || "",
                date_2: rental.date_2 || "",
                express_invoice_id: null,
                express_invoice_url: null,
                financing: 0,
                financing_details: "",
                id: selectedVehicle.id,
                insurance_date: null,
                insurance_policy: null,
                insurance_status_id: null,
                item_id: selectedVehicle.id,
                licence_plate: selectedVehicle.licence_plate || "",
                location_id_2: 0,
                location_name: 0,
                low: 0,
                number_rentals: 0,
                purchase_date: null,
                purchase_price: 0,
                purchased_from: 0,
                renting: selectedVehicle.renting || false,
                retirement_date: null,
                sale_date: null,
                sale_price: 0,
                sold_to: null,
                updated_at: selectedVehicle.updated_at || "",
                vechicle_chassis: selectedVehicle.vechicle_chassis,
                vehicle_color: selectedVehicle.vehicle_color || "",
                vehicle_mileage: selectedVehicle.vehicle_mileage || "",
                vehicle_model_id: selectedVehicle.vehicle_model_id,
                vehicle_options: selectedVehicle.vehicle_options,
                vehicle_status_id: selectedVehicle.vehicle_status_id,
                vehicle_year: selectedVehicle.vehicle_year || ""
              };
              responseVehicles.data.push(vehicleToAdd);
            } catch (pushError) {
             }
          }
        }
      }

      return responseVehicles;
    } catch (error) {
       return { data: [] };
    }
  }

  // Utility Methods
    duration = (date1, date2, forEffectives = false) => {
    let days = moment.utc(date2).diff(date1, "days");
    
    if(forEffectives) {
      days += 1;
    }
    
    const result = days || 0;
    
    return result;
  };getModelName = (modelId) => {
    const { models } = this.state;
    const selectedModel = head(filter(propEq("id", modelId), models));
    return selectedModel ? selectedModel.model_name : "";
  };

  getModelName1() {
    return this.getModelName(this.state.vehicle_model_1);
  }

  getModelName2() {
    return this.getModelName(this.state.vehicle_model_2);
  }

    async getModelPrices1() {
    const { models, tourPrices, vehicle_model_1 } = this.state;
    
    if (!models || !tourPrices || !vehicle_model_1) {
      return 0;
    }
    
    const selectedModel = head(filter(propEq("id", vehicle_model_1), models));

    if (!selectedModel) {
      return 0;
    }

    if (selectedModel && selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    const selectedUpPrice = head(
      filter(
        propEq("price_item_sub_type", `tour_${selectedModel.upgrade_type}`),
        tourPrices
      )
    );
    
    const price = selectedUpPrice ? selectedUpPrice.price : 0;
    return price;
  }async getModelPrices2() {
    const { models, tourPrices, vehicle_model_2 } = this.state;
    
    if (!models || !tourPrices || !vehicle_model_2) {
      return 0;
    }
    
    const selectedModel = head(filter(propEq("id", vehicle_model_2), models));

    if (!selectedModel) {
      return 0;
    }

    if (selectedModel && selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    const selectedUpPrice = head(
      filter(
        propEq("price_item_sub_type", `tour_${selectedModel.upgrade_type}`),
        tourPrices
      )
    );
    const price = selectedUpPrice ? selectedUpPrice.price : 0;
    return price;
  }

  checkOneDay = (bike) => {
    try {
      // Verificar que tenemos las fechas necesarias
      if (!this.state.date_2 || !this.state.date_1) {
        return false;
      }
      
      const date2 = Date.parse(this.state.date_2);
      if (isNaN(date2)) {
        return false;
      }
      
      let nextDay = new Date(date2);
      nextDay.setDate(nextDay.getDate() + 1);
      
      const nextDayString = nextDay.toISOString().slice(0, 10);
      const date1String = this.state.date_1;
      
      return nextDayString === date1String;
    } catch (error) {
       return false;
    }
  }

  getStripeType(rental) {
    if (!rental || !rental.booking) {
      return null;
    }
    
    if (!isNil(rental.booking.tour_id) && rental.booking.tour_id > 0) {
      return rental.booking.p4m ? "p4m" : "tours";
    }
    return null;
  }

  isUserStripe = (rental) => {
    if (!isNil(rental) && rental.booking) {
      const stripeType = this.getStripeType(rental);
      if (stripeType && stripeType !== "p4m") {
        const stripeKey = `stripe_${stripeType}`;
        return rental.driver && rental.driver[stripeKey];
      }
    }
    return false;
  };

  // Main data fetching using toursRefactored endpoints
  async fetchData() {
    try {
      const { id } = this.props.match.params;
      if (!id) {
        throw new Error("No tour ID provided");
      }
      
      // Inicializar el servicio de tours refactorizados
      const toursService = new ToursRefactoredService();
      let rentalData;
      let isPendingTour = false;
      
      try {
        // Intentar obtener el tour usando el endpoint unificado
        rentalData = await toursService.getTour(id);
        
        // Determinar si es un tour pendiente basado en el status
        isPendingTour = rentalData.rental_status === 0 || rentalData.rental_status === "0";
        
      } catch (error) {
        // Si falla el endpoint unificado, intentar con endpoints específicos
        try {
          // Intentar obtener como tour pendiente
          rentalData = await toursService.getPendingTour(id);
          isPendingTour = true;
        } catch (pendingError) {
          try {
            // Intentar obtener como tour procesado
            rentalData = await toursService.getProcessedTour(id);
            isPendingTour = false;
          } catch (processedError) {
            throw new Error("Tour not found in toursRefactored endpoints");
          }
        }
      }
      
      // Validar que booking existe antes de continuar
      if (!rentalData.booking) {
        

        // Intentar obtener el booking por separado si hay booking_id
        if (rentalData.booking_id) {
          try {
             const dataProvider = await dataProviderFactory("rest");
            const bookingResponse = await dataProvider(GET_ONE, 'bookings', { id: rentalData.booking_id });
            if (bookingResponse && bookingResponse.data) {
               rentalData.booking = bookingResponse.data;
            }
          } catch (bookingError) {
           }
        }

        // Si aún no hay booking data, continuar con datos mínimos
        if (!rentalData.booking) {
          this.setState({
            rental: rentalData,
            loading: false,
            error: null
          });
          return;
        }
      }
      
      // Fetch supporting data using existing dataProvider
       const dataProvider = await dataProviderFactory("rest");
      const [vehicleModels, responseLocations, gpsPrices, insurancePrices] = await Promise.all([
        dataProvider(GET_LIST, "vehicle_models", {
          filter: { active: true, type: isPendingTour ? "2" : "2_2" },
          pagination: { page: 1, perPage: 99999 },
          sort: { field: "order", order: "ASC" },
        }),
        dataProvider(GET_LIST, "locations", {
          filter: { only_bases: "true" },
          pagination: { page: 1, perPage: 999 },
          sort: { field: "created_at", order: "DESC" },
        }),
        this.gpsPrices((rentalData.booking && rentalData.booking.price_date) || new Date()),
        this.insurancePrices((rentalData.booking && rentalData.booking.price_date) || new Date())
      ]);

      const priceDate = path(['booking', 'price_date'], rentalData);
      const responseTourPrices = await this.getTourPrices(rentalData.booking.tour_id, priceDate);

      // Calculate initial values - handle different data structures
      const effective_start_date = isPendingTour 
        ? rentalData.booking.tour.effective_start_date 
        : rentalData.effective_start_date;
      const effective_end_date = isPendingTour 
        ? rentalData.booking.tour.effective_end_date 
        : rentalData.effective_end_date;
      
      const effective_start = moment(effective_start_date).utc();
      const effective_end = moment(effective_end_date).utc();
      const efectiveDays = this.duration(effective_start, effective_end, true);

      // Calculate prices
      const singlePrice = rentalData.booking.r_single ? 
        prop("price", head(filter(propEq("price_item_sub_type", "tour_single"), responseTourPrices.data))) : 0;
      
      const tourTotal = prop("price", head(filter(propEq("price_item_sub_type", "tour_total"), responseTourPrices.data)));
      const tourPassengerPrice = prop("price", head(filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data)));

      // NUEVA LÓGICA: Cargar modelo correctamente según el tipo de tour
      let selectedModel;
       
      if (isPendingTour) {
        // Para tours PENDING: cargar modelo desde booking.vehicle_model_1
        const vehicleModelId = parseInt(rentalData.booking.vehicle_model_1);
         selectedModel = head(filter(propEq("id", vehicleModelId), vehicleModels.data));
       } else {
        // Para tours PROCESADOS: cargar modelo desde rental (lógica actual)
        const vehicleModelId = parseInt(rentalData.booking.vehicle_model_1);
        selectedModel = head(filter(propEq("id", vehicleModelId), vehicleModels.data));
       }

      const tourTotal1 = selectedModel && selectedModel.model_name === "Own Motorcycle" ? tourPassengerPrice * efectiveDays : tourTotal;

      const gpsPrice = rentalData.booking.r_gps ? 
        prop("price", head(filter(propEq("price_item_type", "gps_device"), gpsPrices.data))) : 0;

      const passengerPrice = !isNil(rentalData.booking.p_first_name) ? tourPassengerPrice * efectiveDays : 0;

      const vipInsurancePrice = rentalData.booking.r_insurance ?
        prop("price", head(filter(propEq("price_item_id", 1), filter(propEq("price_item_type", "insurance"), insurancePrices.data)))) : 0;

      const cancelInsurancePercentage0 = rentalData.booking.r_cancel_insurance ?
        prop("percentage", head(filter(propEq("price_item_id", 3), insurancePrices.data))) : 0;

      const cancelInsuranceValue1 = rentalData.booking.r_cancel_insurance ?
        ((tourTotal1 + gpsPrice * efectiveDays + passengerPrice + singlePrice) * cancelInsurancePercentage0) / 100 : 0;

      const dayActual = moment(Date.now()).format("YYYY-MM-DD");
      // CORRECCIÓN: 60 días según requerimientos
      const rentalAheadSixtyDays = moment(effective_start_date).diff(dayActual, "days") >= 60;
      
      // Calcular depósito base: 500 + 500 si tiene pasajero
      let calculateDepositToCharge = rentalAheadSixtyDays ? 500 + (passengerPrice > 0 ? 500 : 0) : 0;
      
      // Agregar seguro de cancelación si existe
      if (rentalData.booking.r_cancel_insurance) {
        calculateDepositToCharge += cancelInsuranceValue1;
      }

      // CORRECCIÓN: Seguir la lógica exacta del componente original - rentalTotal1 NO incluye rewards ni discount
      const rentalTotal1 = cancelInsuranceValue1 + (tourTotal1 + (gpsPrice * efectiveDays) + (vipInsurancePrice * efectiveDays) + passengerPrice + singlePrice + (selectedModel && selectedModel.model_name === "Own Motorcycle" ? 500 : 0));

      // Si está a menos de 60 días, cobrar la cantidad entera
      if (moment(effective_start_date).diff(Date.now(), "days") < 60) {
        calculateDepositToCharge = rentalTotal1;
      }

      // Set initial state based on tour type
      if (isPendingTour) {
        this.handlePendingTourData({ data: rentalData }, vehicleModels, responseLocations, responseTourPrices, gpsPrices, insurancePrices, priceDate, cancelInsurancePercentage0, calculateDepositToCharge, cancelInsuranceValue1);
      } else {
        this.handleProcessedTourData({ data: rentalData }, vehicleModels, responseLocations, responseTourPrices, gpsPrices, insurancePrices, priceDate, cancelInsurancePercentage0, calculateDepositToCharge, cancelInsuranceValue1);
      }

    } catch (error) {
       this.setState({ 
        loading: false, 
        error: error.message || "Error loading tour data. Please try again." 
      });
    }
  }

  // Métodos para usar endpoints de toursRefactored
  async validateTourData(tourData) {
    try {
      const { id } = this.props.match.params;
      const toursService = new ToursRefactoredService();
      
       const validationResult = await toursService.validateTour(id, tourData);
      
       return validationResult;
    } catch (error) {
       throw error;
    }
  }

  async processTourWithRefactoredService(tourData) {
    try {
      const { id } = this.props.match.params;
      const toursService = new ToursRefactoredService();
      
       
      if (this.state.isPendingTour) {
        const result = await toursService.processTour(id, tourData);
         return result;
      } else {
        const result = await toursService.updateProcessedTour(id, tourData);
         return result;
      }
    } catch (error) {
       throw error;
    }
  }

  // Métodos para manejar diferentes tipos de tours
  handlePendingTourData(responseRental, vehicleModels, responseLocations, responseTourPrices, gpsPrices, insurancePrices, priceDate, cancelInsurancePercentage0, calculateDepositToCharge, cancelInsuranceValue1) {
    // Lógica para tours pendientes (lógica actual)
   
    
    const vehicleModel1Value = parseInt(responseRental.data.booking.vehicle_model_1) || 0;
  
    this.setState({
      isPendingTour: true,
      rental: responseRental.data,
      models: vehicleModels.data,
      locations: responseLocations.data,
      tourPrices: responseTourPrices.data,
        gpsPrices: Array.isArray(gpsPrices.data) ? gpsPrices.data : [],
      insurancePrices: insurancePrices.data,
      priceDate,
      
      // Form values
      vehicle_model_1: vehicleModel1Value,
      vehicle_model_2: responseRental.data.booking.vehicle_model_2,
      vehicleId: 0, // Se establecerá después de cargar los vehículos
      gpsDeviceId: 0, // Se establecerá después de cargar los GPS devices
      rewards: responseRental.data.booking.rewards,
      r_single: responseRental.data.booking.r_single,
      r_double: !responseRental.data.booking.r_single,
      r_gps: responseRental.data.booking.r_gps,
      r_cancel_insurance: responseRental.data.booking.r_cancel_insurance,
      r_insurance_id: normalizeInsuranceId(
        responseRental.data.booking.r_insurance_id != null
          ? responseRental.data.booking.r_insurance_id
          : responseRental.data.booking.r_insurance
      ),
      r_insurance: isPaidInsurance(
        responseRental.data.booking.r_insurance_id != null
          ? responseRental.data.booking.r_insurance_id
          : responseRental.data.booking.r_insurance
      ),
      
      // Fechas del tour
      date_1: responseRental.data.date_1,
      date_2: responseRental.data.date_2,
      
      // ✅ CORRECCIÓN: Inicializar imt_commentN y imt_comment para tours pendientes
      imt_comment: responseRental.data.imt_comment || "",
      imt_commentN: responseRental.data.imt_comment || "",
      
      // Pricing
      cancelInsurancePercentage: cancelInsurancePercentage0,
      value_to_charge: calculateDepositToCharge.toFixed(2),
      valueToChargeConfirmed: calculateDepositToCharge.toFixed(2),
      // Inicializar currentValueToCharge con el valor calculado
      currentValueToCharge: calculateDepositToCharge,
      // Inicializar rentalTotal1 y rentalTotal2
      rentalTotal1: calculateDepositToCharge,
      rentalTotal2: calculateDepositToCharge,
      
      loading: false
    }, async () => {
    
      // Load dependent data - pasar vehicle_model_1 explícitamente
      const [vehicles, model1Price, model2Price, gpsDevices, clientRewards] = await Promise.all([
        this.getVehiclesWithModel(responseRental.data.booking.vehicle_model_1),
        this.getModelPrices1(),
        this.getModelPrices2(),
        this.getGpsDevices(),
        this.getAvailableRewards(responseRental.data.driver.id),
      ]);

      // Verificar si ya existe un GPS asignado al tour desde device o rental_items
      let selectedGpsId = 0;
      let shouldEnableGps = this.state.r_gps;
      
      // Primero verificar si hay device con GPS asignado
      if (responseRental.data.device && responseRental.data.device.length > 0) {
        const gpsDevice = responseRental.data.device.find(item => 
          item.RentalItem && item.RentalItem.rental_item_type === 'gps_device'
        );
        if (gpsDevice) {
          selectedGpsId = gpsDevice.id;
          shouldEnableGps = true; // Si hay GPS asignado, habilitar r_gps
        }
      }
      
      // Si no hay device, verificar si hay rental_items con GPS
      if (selectedGpsId === 0 && responseRental.data.rental_items && responseRental.data.rental_items.length > 0) {
        const gpsRentalItem = responseRental.data.rental_items.find(item => 
          item.rental_item_type === 'gps_device'
        );
        if (gpsRentalItem) {
          selectedGpsId = gpsRentalItem.rental_item_id;
          shouldEnableGps = true; // Si hay GPS en rental_items, habilitar r_gps
        }
      }
      
      // IMPORTANTE: NO autoseleccionar GPS si no hay uno asignado
      // Si no hay GPS pre-asignado, mantener gpsDeviceId = 0 para mostrar alerta
      // Solo se autoselecciona si realmente hay un GPS asignado al tour
      if (selectedGpsId === 0) {
        // No hay GPS asignado, mantener en 0 para que el usuario seleccione
        // Esto permitirá que aparezca la alerta "Please select GPS device"
        selectedGpsId = 0;
      }
      
      // IMPORTANTE: Agregar el GPS ya asignado a la lista de GPS disponibles (como en processTourEdit)
      // Esto asegura que el GPS asignado aparezca en el select aunque no esté disponible en el endpoint
      if (selectedGpsId > 0 && gpsDevices.data) {
        // Verificar si el GPS ya asignado no está en la lista
        const gpsAlreadyInList = gpsDevices.data.find(gps => gps.id === selectedGpsId);
        if (!gpsAlreadyInList) {
          // Buscar el GPS en device para obtener el modelo
          let gpsModel = "GPS Device";
          if (responseRental.data.device && responseRental.data.device.length > 0) {
            const gpsDevice = responseRental.data.device.find(item => 
              item.RentalItem && item.RentalItem.rental_item_type === 'gps_device'
            );
            if (gpsDevice) {
              gpsModel = gpsDevice.model;
            }
          }
          
          // Agregar el GPS asignado a la lista
          gpsDevices.data.push({
            id: selectedGpsId,
            model: gpsModel
          });
        }
      }

      // CORRECCIÓN: Si el modelo es K1600GT, deshabilitar y limpiar GPS
      const isK1600GT = this.getModelName1() === "K1600GT";
      const finalGpsDeviceId = isK1600GT ? 0 : selectedGpsId;
      const finalR_gps = isK1600GT ? false : shouldEnableGps;

      this.setState({
        vehicles: vehicles.data,
        gpsDevices: gpsDevices.data,
        model1Price,
        model2Price,
        clientRewards: clientRewards, // ✅ PARA TOURS NUEVOS: MOSTRAR REWARDS DISPONIBLES COMPLETOS
        originalClientRewards: clientRewards, // ✅ GUARDAR EL VALOR ORIGINAL
        gpsDeviceId: finalGpsDeviceId, // Limpiar GPS si es K1600GT
        r_gps: finalR_gps, // Deshabilitar GPS si es K1600GT
        cancelInsuranceValue: cancelInsuranceValue1,
        r_insurance_disabled: this.getModelName1() === "Own Motorcycle",
        r_gps_disabled: isK1600GT, // Deshabilitar checkbox de GPS para K1600GT
        // PRESERVAR vehicle_model_1 para evitar que se pierda en el segundo setState
        vehicle_model_1: this.state.vehicle_model_1,
      }, () => {
        // Actualizar el desglose de precios después de cargar los datos
        this.updatePricingBreakdown();
     
      });

    });
  }

  async handleProcessedTourData(responseRental, vehicleModels, responseLocations, responseTourPrices, gpsPrices, insurancePrices, priceDate, cancelInsurancePercentage0, calculateDepositToCharge, cancelInsuranceValue1) {
    // Lógica para tours ya procesados
    // Priorizar el vehículo desde rental_items si existe
    const selectedVehicleFromItems = responseRental.data.selected_vehicle_from_items;
    // Verificar que vehicle y device existan antes de acceder a ellos
    const vehicleArray = responseRental.data.vehicle || [];
    const deviceArray = responseRental.data.device || [];
    
    const selectedVehicle = isEmpty(vehicleArray)
      ? null
      : head(vehicleArray);
    const selectedGpsDevice = head(deviceArray) || { id: 0 };
    
    // Verificar si el tour tiene GPS seleccionado
    const hasGpsSelected = deviceArray.length > 0;
 
    // Calcular cargos suplementarios
    let suplementRemeaning = 0;
    if (responseRental.data.payments && responseRental.data.payments.length > 0) {
      const charge = prop("charges", head(responseRental.data.payments));
      if (charge && charge.length > 0) {
        charge.filter(c => {
          if (c.status == false && c.extra_charge == true) {
            suplementRemeaning += c.value;
          }
        });
      }
    }

    // Calcular value_to_charge usando la lógica de processTourEdit.js
    let valueToCharge = calculateDepositToCharge;
    let valueToChargeConfirmed = calculateDepositToCharge;
    
    // Calcular rentalTotal1 para el cálculo (mover fuera del if para que esté disponible en todo el scope)
    const effective_start = moment(responseRental.data.effective_start_date).utc();
    const effective_end = moment(responseRental.data.effective_end_date).utc();
    const efectiveDays = this.duration(effective_start, effective_end, true);
    
    const tourTotal = prop("price", head(filter(propEq("price_item_sub_type", "tour_total"), responseTourPrices.data))) || 0;

    const tourPassengerPrice = prop("price", head(filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data))) || 0;

    const singlePrice = responseRental.data.single && responseRental.data.single.length > 0 ? 
      (prop("price", head(filter(propEq("price_item_sub_type", "tour_single"), responseTourPrices.data))) || 0) : 0;

    const passengerPrice = !isNil(responseRental.data.booking.p_first_name) ? tourPassengerPrice * efectiveDays : 0;

    const gpsPrice = deviceArray.length > 0 ? 
      (prop("price", head(filter(propEq("price_item_type", "gps_device"), gpsPrices.data))) || 0) : 0;
    const vipInsurancePrice = responseRental.data.insurance && responseRental.data.insurance.length > 0 ?
      (prop("price", head(filter(propEq("price_item_id", 1), filter(propEq("price_item_type", "insurance"), insurancePrices.data)))) || 0) : 0;
    
    // ✅ CORRECCIÓN: Determinar si es "Own Motorcycle" usando selectedVehicle en lugar de this.getModelName1()
    const selectedModelName = selectedVehicle && selectedVehicle.model ? selectedVehicle.model.model_name : "";
    const tourTotal1 = selectedModelName === "Own Motorcycle" ? passengerPrice + 500 : tourTotal;
    
    // CORRECCIÓN: Calcular model1Price correctamente
    let model1Price = 0;
    try {
      const selectedModel = selectedVehicle && selectedVehicle.model;
      
      if (selectedModel && selectedModel.id) {
        // Buscar el modelo en vehicleModels en lugar de this.state.models
        const modelFromList = head(filter(propEq("id", selectedModel.id), vehicleModels.data));
        
        if (modelFromList && modelFromList.upgrade_type) {
          // Buscar el precio directamente en responseTourPrices
          const selectedUpPrice = head(
            filter(
              propEq("price_item_sub_type", `tour_${modelFromList.upgrade_type}`),
              responseTourPrices.data
            )
          );
          model1Price = selectedUpPrice ? selectedUpPrice.price : 0;
        }
      }
    } catch (error) {
      console.error('Error calculando model1Price:', error);
      model1Price = 0;
    }
    
    // Usar el cancelInsuranceValue1 que viene como parámetro de la función
    // No redeclarar aquí ya que viene desde el scope superior
    
    // Calcular pendingSuplement (mover fuera del if)
    let pendingSuplement = 0;
    if (responseRental.data.payments && responseRental.data.payments.length > 0) {
      const charge = prop("charges", head(responseRental.data.payments));
      if (charge && charge.length > 0) {
        pendingSuplement = sum(map(prop("value"), filter(allPass([propEq("status", false), propEq("extra_charge", true)]), charge)));
      }
    }

    // CORRECCIÓN: Seguir la lógica exacta del componente original - rentalTotal1 incluye todos los componentes
    // ✅ AGREGAR VALIDACIONES PARA EVITAR NaN
    const safeCancelInsuranceValue1 = cancelInsuranceValue1 || 0;
    const safeTourTotal1 = tourTotal1 || 0;
    const safeGpsPrice = gpsPrice || 0;
    const safeVipInsurancePrice = vipInsurancePrice || 0;
    const safePassengerPrice = passengerPrice || 0;
    const safeSinglePrice = singlePrice || 0;
    const safeModel1Price = model1Price || 0;
    const safePendingSuplement = pendingSuplement || 0;
    const safeDiscount = responseRental.data.discount || 0;
    const safeRewards = responseRental.data.booking.reward_used ? (responseRental.data.booking.rewards || 0) : 0;
    
    const rentalTotal1 = safeCancelInsuranceValue1 + 
      (safeTourTotal1 + (safeGpsPrice * efectiveDays) + (safeVipInsurancePrice * efectiveDays) + safePassengerPrice + safeSinglePrice + safeModel1Price + safePendingSuplement) - 
      safeDiscount - 
      safeRewards;
    
    if (responseRental.data.payments && responseRental.data.payments.length > 0) {
      const charges = prop("charges", head(responseRental.data.payments));

      const isChargePaid = (c) => c.status === true || c.status === 1;
      const isMarkedToRefund = (c) => c.to_refund === true || c.to_refund === 1;
      const totalRefunded =
        sum(
          map(
            prop("refunded_value"),
            filter(isMarkedToRefund, filter(isChargePaid, charges))
          )
        ) || 0;

      const payedSuplement =
        sum(
          map(
            prop("value"),
            filter(allPass([isChargePaid, propEq("extra_charge", true)]), charges)
          )
        ) || 0;

      const totalPayed = (sum(map(prop("value"), filter(isChargePaid, charges))) + payedSuplement) || 0;

      // Neto pagado = bruto cobrado − reembolsos (el refund no anula el cargo completo)
      const calculatedValue = rentalTotal1 - totalPayed + totalRefunded;
      valueToCharge = isNaN(calculatedValue) ? 0 : calculatedValue;
      valueToChargeConfirmed = isNaN(calculatedValue) ? 0 : calculatedValue;
    }

    const vehicleModelIdForLoad = (selectedVehicle && selectedVehicle.vehicle_model_id) || (responseRental.data.booking && responseRental.data.booking.vehicle_model_1);
    const rentalData = responseRental.data;
    const canLoadVehicles = vehicleModelIdForLoad && rentalData && rentalData.booking && rentalData.booking.tour_id;
    const vehiclesResponse = canLoadVehicles
      ? await this.getVehiclesWithModel(vehicleModelIdForLoad, rentalData)
      : { data: [] };
    const initialVehiclesList = Array.isArray(vehiclesResponse.data) ? vehiclesResponse.data : [];

    this.setState({
      isPendingTour: false,
      vehicles: initialVehiclesList,
      rental: rentalData,
      models: vehicleModels.data,
      locations: responseLocations.data,
      tourPrices: responseTourPrices.data,
        gpsPrices: Array.isArray(gpsPrices.data) ? gpsPrices.data : [],
      insurancePrices: insurancePrices.data,
      priceDate,
      
      // Form values para tours ya procesados
      vehicle_model_1: selectedVehicle ? selectedVehicle.vehicle_model_id : responseRental.data.booking.vehicle_model_1,
      vehicle_model_2: responseRental.data.booking.vehicle_model_2,
      vehicleId: selectedVehicle ? selectedVehicle.id : 0,
      gpsDeviceId: hasGpsSelected ? selectedGpsDevice.id : 0,
      rewards: responseRental.data.booking.rewards,
      r_single: responseRental.data.single && responseRental.data.single.length > 0,
      r_double: !(responseRental.data.single && responseRental.data.single.length > 0),
      r_gps: hasGpsSelected,
      r_cancel_insurance: responseRental.data.cancel_insurance && responseRental.data.cancel_insurance.length > 0,
      r_insurance_id: normalizeInsuranceId(
        (responseRental.data.insurance &&
          responseRental.data.insurance[0] &&
          responseRental.data.insurance[0].id) ||
          (responseRental.data.booking &&
            responseRental.data.booking.r_insurance_id) ||
          responseRental.data.booking.r_insurance
      ),
      r_insurance: isPaidInsurance(
        (responseRental.data.insurance &&
          responseRental.data.insurance[0] &&
          responseRental.data.insurance[0].id) ||
          (responseRental.data.booking &&
            responseRental.data.booking.r_insurance_id) ||
          responseRental.data.booking.r_insurance
      ),
      low_seat: responseRental.data.seat && responseRental.data.seat.length > 0,
      
      // Fechas del tour
      date_1: responseRental.data.date_1,
      date_2: responseRental.data.date_2,
      
      // Campos adicionales para tours procesados
      imt_commentN: "", // Initialize as empty - comments will be concatenated later
      comments: responseRental.data.imt_comment || "",
      extra_comments: responseRental.data.extra_comments || "",
      r_documentacion: responseRental.data.r_documentacion || false,
      chargeSuplement: suplementRemeaning,
      refund_value: 0,
      chargeId: 0,
      
      // Opciones adicionales para tours procesados
      partial: 0,
      resend: false,
      sendFinalConfirmation: false,
      valid_charge: false,
      form_error: false,
      valueAvalaible: 0,
      
      // Campos de comentarios adicionales
      invoice_comments: "", // Initialize as empty - comments will be concatenated later
      
      // Pricing
      cancelInsurancePercentage: cancelInsurancePercentage0,
      // ✅ NUEVO: Usar calculated_due del API si está disponible, sino usar el cálculo local
      value_to_charge: responseRental.data.calculated_due !== undefined && responseRental.data.calculated_due !== null 
        ? responseRental.data.calculated_due.toFixed(2)
        : (isNaN(valueToCharge) ? 0 : valueToCharge).toFixed(2),
      valueToChargeConfirmed: responseRental.data.calculated_due !== undefined && responseRental.data.calculated_due !== null 
        ? responseRental.data.calculated_due.toFixed(2)
        : (isNaN(valueToChargeConfirmed) ? 0 : valueToChargeConfirmed).toFixed(2),
      // Inicializar currentValueToCharge con el valor total calculado (sin descuentos de charges)
      currentValueToCharge: isNaN(rentalTotal1) ? 0 : rentalTotal1,
      // Inicializar rentalTotal1 y rentalTotal2
      rentalTotal1: isNaN(rentalTotal1) ? 0 : rentalTotal1,
      rentalTotal2: isNaN(rentalTotal1) ? 0 : rentalTotal1 + (this.state.model2Price || 0) - (this.state.model1Price || 0), // Se actualizará después con el precio del modelo 2
      discount: responseRental.data.discount || 0, // Asegurar que el campo discount refleje el valor real del rental
      
      loading: false
    }, async () => {
      try {
        const modelId = vehicleModelIdForLoad || this.state.vehicle_model_1;
        const rentalData = responseRental.data;
        const driverId = rentalData.driver && rentalData.driver.id;

        const vehiclesPromise = modelId && rentalData && rentalData.booking && rentalData.booking.tour_id
          ? this.getVehiclesWithModel(modelId, rentalData)
          : Promise.resolve({ data: [] });

        const [vehiclesRes, model1Price, model2Price, gpsDevices, clientRewards] = await Promise.all([
          vehiclesPromise,
          this.getModelPrices1(),
          this.getModelPrices2(),
          this.getGpsDevices(),
          driverId ? this.getAvailableRewards(driverId) : Promise.resolve([]),
        ]);

        const vehiclesList = vehiclesRes && Array.isArray(vehiclesRes.data) ? vehiclesRes.data : [];

        let selectedVehicleId = selectedVehicle ? selectedVehicle.id : 0;
        const vehiclesToSet = vehiclesList.length > 0 ? vehiclesList : this.state.vehicles || [];
  
      // Verificar si el GPS seleccionado existe en la lista de GPS disponibles
      let finalGpsDeviceId = this.state.gpsDeviceId; // Mantener el GPS seleccionado del primer setState
      let shouldEnableGps = this.state.r_gps;
      
      // Primero verificar si hay device con GPS asignado
      if (responseRental.data.device && responseRental.data.device.length > 0) {
        const gpsDevice = responseRental.data.device.find(item => 
          item.RentalItem && item.RentalItem.rental_item_type === 'gps_device'
        );
        if (gpsDevice) {
          finalGpsDeviceId = gpsDevice.id;
          shouldEnableGps = true; // Si hay GPS asignado, habilitar r_gps
        }
      }
      
      // Si no hay device, verificar si hay rental_items con GPS
      if (finalGpsDeviceId === 0 && responseRental.data.rental_items && responseRental.data.rental_items.length > 0) {
        const gpsRentalItem = responseRental.data.rental_items.find(item => 
          item.rental_item_type === 'gps_device'
        );
        if (gpsRentalItem) {
          finalGpsDeviceId = gpsRentalItem.rental_item_id;
          shouldEnableGps = true; // Si hay GPS en rental_items, habilitar r_gps
        }
      }
      
      // IMPORTANTE: NO autoseleccionar GPS si no hay uno asignado
      // Si no hay GPS pre-asignado, mantener gpsDeviceId = 0 para mostrar alerta
      if (finalGpsDeviceId === 0 && hasGpsSelected && gpsDevices.data && gpsDevices.data.length > 0) {
        // Buscar si el GPS seleccionado existe en la lista de GPS disponibles
        const gpsExists = gpsDevices.data.some(gps => gps.id === selectedGpsDevice.id);
        
        if (gpsExists) {
          finalGpsDeviceId = selectedGpsDevice.id;
        } else {
          // Si no existe el GPS seleccionado, NO autoseleccionar el primero
          // Mantener en 0 para que aparezca la alerta
          finalGpsDeviceId = 0;
        }
      }
      
      // IMPORTANTE: Agregar el GPS ya asignado a la lista de GPS disponibles (como en processTourEdit)
      // Esto asegura que el GPS asignado aparezca en el select aunque no esté disponible en el endpoint
      if (finalGpsDeviceId > 0 && gpsDevices.data) {
        // Verificar si el GPS ya asignado no está en la lista
        const gpsAlreadyInList = gpsDevices.data.find(gps => gps.id === finalGpsDeviceId);
        if (!gpsAlreadyInList) {
          // Buscar el GPS en device para obtener el modelo
          let gpsModel = "GPS Device";
          if (responseRental.data.device && responseRental.data.device.length > 0) {
            const gpsDevice = responseRental.data.device.find(item => 
              item.RentalItem && item.RentalItem.rental_item_type === 'gps_device'
            );
            if (gpsDevice) {
              gpsModel = gpsDevice.model;
            }
          }
          
          // Agregar el GPS asignado a la lista
          gpsDevices.data.push({
            id: finalGpsDeviceId,
            model: gpsModel
          });
        }
      }

      this.setState({
        vehicles: vehiclesToSet,
        gpsDevices: (gpsDevices && gpsDevices.data) ? gpsDevices.data : [],
        model1Price,
        model2Price,
        clientRewards: clientRewards || [],
        originalClientRewards: clientRewards || [],
        vehicleId: selectedVehicleId,
        gpsDeviceId: finalGpsDeviceId,
        r_gps: shouldEnableGps,
        cancelInsuranceValue: cancelInsuranceValue1,
        r_insurance_disabled: this.getModelName1() === "Own Motorcycle",
        r_gps_disabled: this.getModelName1() === "K1600GT",
      }, () => {
        this.updatePricingBreakdown();
      });

        this.recalcularValueToCharge();
      } catch (err) {
        console.error("Error cargando datos dependientes en tour procesado:", err);
        this.setState((prev) => ({
          vehicles: prev.vehicles && prev.vehicles.length ? prev.vehicles : [],
        }));
      }
    });
  }

  handleAdditionalFieldChange = (event, fieldName) => {
    const newValue = event.target.value;
    
    // ✅ CORRECCIÓN: Sincronizar imt_comment cuando cambia imt_commentN
    if (fieldName === 'imt_commentN') {
      this.setState({ 
        [fieldName]: newValue,
        imt_comment: newValue // Sincronizar ambos campos
      });
    } else {
      this.setState({ [fieldName]: newValue });
    }
  };

  handleCheckChange = (event, item, displayValue = null) => {
    const { notifications } = this.state;
    
    switch(item) {
      case "r_double":
        // Lógica original: si Double está activo, lo desactiva y activa Single
        // Si Double está inactivo, lo activa y desactiva Single
        if (this.state.r_double) {
          this.setState({
            r_single: true,
            r_double: false,
          }, () => {
            // Recalcular automáticamente cuando se cambia la opción de habitación
            this.recalcularValorTotalTour();
          });
        } else {
          this.setState({
            r_single: false,
            r_double: true,
          }, () => {
            // Recalcular automáticamente cuando se cambia la opción de habitación
            this.recalcularValorTotalTour();
          });
        }
        break;
      case "r_single":
        // Lógica original: si Single está activo, lo desactiva y activa Double
        // Si Single está inactivo, lo activa y desactiva Double
        if (this.state.r_single) {
          this.setState({
            r_double: true,
            r_single: false,
          }, () => {
            // Recalcular automáticamente cuando se cambia la opción de habitación
            this.recalcularValorTotalTour();
          });
        } else {
          this.setState({
            r_double: false,
            r_single: true,
          }, () => {
            // Recalcular automáticamente cuando se cambia la opción de habitación
            this.recalcularValorTotalTour();
          });
        }
        break;
      case "r_cancel_insurance":
        this.setState({
          r_cancel_insurance: !this.state.r_cancel_insurance,
        }, () => {
          // Recalcular automáticamente cuando se cambia el seguro de cancelación
          this.recalcularValorTotalTour();
        });
        break;
      case "r_gps":
        // IMPORTANTE: NO autoseleccionar GPS automáticamente
        // Cuando se activa el GPS, el usuario debe seleccionar manualmente
        const newR_gps = !this.state.r_gps;
        //console.log('🔄 Toggle GPS changed:', { from: this.state.r_gps, to: newR_gps });
        
        this.setState({
          gpsDeviceId: newR_gps ? this.state.gpsDeviceId : 0, // Mantener el GPS seleccionado si se activa, resetear si se desactiva
          r_gps: newR_gps,
          // ✅ RESETEAR EL FLAG PARA FORZAR RECÁLCULO
          valueToChargeCalculatedByUpdatePricing: false
        }, () => {
          // Recalcular automáticamente cuando se cambia la opción de GPS
       /*   console.log('🔄 Recalculando valores después de cambiar GPS:', { 
            r_gps: this.state.r_gps,
            gpsDeviceId: this.state.gpsDeviceId,
            gpsPrices: this.state.gpsPrices ? (Array.isArray(this.state.gpsPrices) ? this.state.gpsPrices.length : (this.state.gpsPrices.data ? this.state.gpsPrices.data.length : 0)) : 0
          });*/
          this.recalcularValorTotalTour();
        });
        break;
      case "low_seat":
        this.setState({
          low_seat: !this.state.low_seat,
        }, () => {
          // Recalcular automáticamente cuando se cambia la opción de asiento bajo
          this.recalcularValorTotalTour();
        });
        break;
      case "r_insurance":
        this.setState({
          r_insurance: !this.state.r_insurance,
        }, () => {
          // Recalcular automáticamente cuando se cambia la opción de seguro
          this.recalcularValorTotalTour();
        });
        break;
      case "noConfirmationEmail":
        this.setState({
          noConfirmationEmail: !this.state.noConfirmationEmail,
        });
        break;
      case "checkedF":
        const newCheckedF = !this.state.checkedF;
        // ✅ NUEVO: Usar displayValue si está disponible (del API), sino usar valueToChargeConfirmed
        const valueToUse = displayValue !== null ? parseFloat(displayValue) : this.state.valueToChargeConfirmed;
        
        if (newCheckedF) {
          // ✅ Cuando se marca el checkbox: guardar el valor inicial y habilitar el campo
          const initialValue = isNaN(valueToUse) ? parseFloat(this.state.valueToChargeConfirmed) || 0 : valueToUse;
          
          this.setState({
            checkedF: newCheckedF,
            customValueEnabled: newCheckedF,
            customValueToCharge: initialValue,
            customValueToChargeString: initialValue.toFixed(2),
            initialDisplayValueToCharge: initialValue, // ✅ Guardar el valor inicial para mostrarlo en el título
            confirmedValueToCharge: initialValue,
            isValueConfirmed: newCheckedF,
          });
        } else {
          // ✅ Cuando se desmarca el checkbox: restaurar valores originales
          const originalValue = this.state.initialDisplayValueToCharge > 0 
            ? this.state.initialDisplayValueToCharge 
            : (isNaN(valueToUse) ? parseFloat(this.state.valueToChargeConfirmed) || 0 : valueToUse);
          
          this.setState({
            checkedF: newCheckedF,
            customValueEnabled: newCheckedF,
            customValueToCharge: 0,
            customValueToChargeString: "",
            // Mantener initialDisplayValueToCharge para referencia
            confirmedValueToCharge: originalValue,
            isValueConfirmed: newCheckedF,
            // Restaurar value_to_charge al valor original
            value_to_charge: originalValue.toFixed(2),
            valueToChargeConfirmed: originalValue
          });
        }
        break;
      case "r_documentacion":
        this.setState({
          r_documentacion: !this.state.r_documentacion,
        });
        break;
      case "partial":
        this.setState({
          partial: event.target.value,
        });
        break;
      case "resend":
        this.setState({
          resend: !this.state.resend,
        });
        break;
      case "sendFinalConfirmation":
        this.setState({
          sendFinalConfirmation: !this.state.sendFinalConfirmation,
        });
        break;
    }
  };

  handleChange = (element, type) => {
    let newValue = parseFloat(element.target.value) || 0;
    
    // ✅ PREVENIR VALORES NEGATIVOS EN REWARDS Y DESCUENTOS
    if (type === "rewards" && newValue < 0) {
      newValue = 0;
     // console.log('⚠️ Valor negativo detectado en rewards, estableciendo a 0');
    }
    if (type === "discount" && newValue < 0) {
      newValue = 0;
     // console.log('⚠️ Valor negativo detectado en discount, estableciendo a 0');
    }
    
    // ✅ ACTUALIZAR PRECIOS AUTOMÁTICAMENTE CUANDO CAMBIAN DESCUENTOS O RECOMPENSAS
    if (type === "discount" || type === "rewards") {
      try {
        const shouldInvalidate = this.shouldInvalidateChargeConfirmation();
        // Actualizar el estado principal primero
        const updatedState = {
          [type]: newValue,
          ...(shouldInvalidate ? this.getChargeConfirmationResetState() : {}),
        };
        
        // ✅ ACTUALIZAR CLIENTREWARDS CUANDO CAMBIAN LOS REWARDS
        if (type === "rewards") {
          const currentRewards = this.state.rewards || 0;
          const originalClientRewards = this.state.originalClientRewards || this.state.clientRewards;
          
          // Calcular cuántos rewards se están agregando o quitando
          const rewardsDifference = newValue - currentRewards;
          
          // ✅ Para tours procesados: clientRewards debe mostrar rewards disponibles del cliente
          // Para tours nuevos: clientRewards debe mostrar rewards disponibles menos los usados
          const isProcessedTour = this.state.rental && this.state.rental.booking && this.state.rental.booking.reward_used;
          
          let newClientRewards;
          if (isProcessedTour) {
            // Para tours procesados: mostrar rewards disponibles del cliente
            newClientRewards = originalClientRewards;
          } else {
            // Para tours nuevos: mostrar rewards disponibles menos los usados
            newClientRewards = Math.max(0, originalClientRewards - newValue);
          }
          
          updatedState.clientRewards = newClientRewards;
          
       /*   console.log(`🔄 Actualizando clientRewards:`, {
            currentRewards: currentRewards,
            newRewards: newValue,
            rewardsDifference: rewardsDifference,
            originalClientRewards: originalClientRewards,
            newClientRewards: newClientRewards,
            isProcessedTour: isProcessedTour,
            tourType: isProcessedTour ? 'PROCESADO' : 'NUEVO'
          });*/
        }
        
        // Actualizar el rental con los nuevos valores
        const updatedRental = {
          ...this.state.rental,
          discount: type === "discount" ? newValue : this.state.rental.discount,
          booking: {
            ...this.state.rental.booking,
            rewards: type === "rewards" ? newValue : this.state.rental.booking.rewards,
            reward_used: type === "rewards" ? newValue > 0 : this.state.rental.booking.reward_used
          }
        };
        
        updatedState.rental = updatedRental;
        
        // Actualizar todo el estado de una vez
        this.setState(updatedState, async () => {
         /* console.log(`🔄 Estado actualizado para ${type}:`, {
            newValue: newValue,
            updatedState: updatedState,
            currentDiscount: this.state.discount,
            currentRewards: this.state.rewards,
            currentClientRewards: this.state.clientRewards
          });*/
          
          if (shouldInvalidate) {
            this.notifyChargeConfirmationInvalidated();
          }
          // Recalcular automáticamente todos los precios
          await this.updatePricingBreakdown();
          
         /* console.log(`✅ Precios actualizados automáticamente después de cambiar ${type}:`, {
            discount: this.state.discount,
            rewards: this.state.rewards,
            clientRewards: this.state.clientRewards,
            valueToChargeConfirmed: this.state.valueToChargeConfirmed,
            customValueToCharge: this.state.customValueToCharge,
            firstChoiceTotal: this.state.pricingBreakdown && this.state.pricingBreakdown.final_total
          });*/
        });
      } catch (error) {
        console.error(`❌ Error actualizando precios después de cambiar ${type}:`, error);
      }
    } else {
      // Para otros tipos de cambios, usar el comportamiento original
      this.setState({ [type]: element.target.value }, async () => {
        if (type === "vehicle_model_1") {
          try {
            // Obtener vehículos filtrados por el nuevo modelo seleccionado
            const updatedVehicles = await this.getVehiclesWithModel(element.target.value);
            const updatedGps = await this.getGpsDevices();

            // Para tours PROCESADOS: Obtener el vehículo seleccionado
            let vehicleId = 0;
            if (!this.state.isPendingTour) {
              const selectedVehicle = !isEmpty(this.state.rental.vehicle) ? head(this.state.rental.vehicle) : null;
              if (selectedVehicle && selectedVehicle.vehicle_model_id === parseInt(element.target.value)) {
                vehicleId = selectedVehicle.id;
              }
            }

            // IMPORTANTE: NO autoseleccionar GPS si no hay uno asignado
            // Solo mantener el GPS ya asignado o establecer en 0 para mostrar alerta
            let newGpsDeviceId = this.state.gpsDeviceId; // Mantener el GPS ya asignado
            
            // Si no hay GPS asignado, mantener en 0 para que aparezca la alerta
            if (newGpsDeviceId === 0) {
              newGpsDeviceId = 0;
            }
            
            // IMPORTANTE: Agregar el GPS ya asignado a la lista de GPS disponibles (como en processTourEdit)
            // Esto asegura que el GPS asignado aparezca en el select aunque no esté disponible en el endpoint
            if (this.state.gpsDeviceId > 0 && updatedGps.data) {
              // Verificar si el GPS ya asignado no está en la lista
              const gpsAlreadyInList = updatedGps.data.find(gps => gps.id === this.state.gpsDeviceId);
              if (!gpsAlreadyInList) {
                // Buscar el GPS en device para obtener el modelo
                let gpsModel = "GPS Device";
                if (this.state.rental && this.state.rental.device && this.state.rental.device.length > 0) {
                  const gpsDevice = this.state.rental.device.find(item => 
                    item.RentalItem && item.RentalItem.rental_item_type === 'gps_device'
                  );
                  if (gpsDevice) {
                    gpsModel = gpsDevice.model;
                  }
                }
                
                // Agregar el GPS asignado a la lista
                updatedGps.data.push({
                  id: this.state.gpsDeviceId,
                  model: gpsModel
                });
              }
            }

            // CORRECCIÓN: Si el modelo es K1600GT, deshabilitar y limpiar GPS
            const selectedModel = head(filter(propEq("id", element.target.value), this.state.models));
            const isK1600GT = selectedModel && selectedModel.model_name === "K1600GT";
            const finalGpsDeviceId = isK1600GT ? 0 : newGpsDeviceId;
            const finalR_gps = isK1600GT ? false : this.state.r_gps;

            // Actualizar el estado con los vehículos y dispositivos GPS
            this.setState({
              vehicleId,
              gpsDeviceId: finalGpsDeviceId, // Limpiar GPS si es K1600GT
              r_gps: finalR_gps, // Deshabilitar GPS si es K1600GT
              r_gps_disabled: isK1600GT, // Deshabilitar checkbox de GPS para K1600GT
              vehicles: updatedVehicles.data,
              gpsDevices: updatedGps.data,
            });

            // Recalcular automáticamente el precio cuando se cambia el modelo
            await this.recalcularValorTotalTour();

            // Mostrar notificación de recálculo automático
            if (selectedModel && selectedModel.model_name) {
              const message = isK1600GT 
                ? `Vehicles loaded for model: ${selectedModel.model_name}. GPS is not available for this model.`
                : `Vehicles loaded for model: ${selectedModel.model_name}`;
              this.showStyledNotification(
                message,
                'info'
              );
            }
          } catch (error) {
            this.setState({
              vehicles: [],
              gpsDevices: [],
              vehicleId: 0,
              gpsDeviceId: 0,
            });
          }
        }
      });
    }
  };

  handleCustomValueChange = (event, maxValue = null) => {
    // ✅ CORRECCIÓN: Permitir escribir valores parciales durante la escritura
    // Guardar el valor como string para permitir escritura parcial (ej: "5.", "5.0", etc.)
    let inputValue = event.target.value;
    
    // ✅ Validar que solo contenga números, punto decimal y signo negativo al inicio
    // Permitir valores como: "5", "5.", "5.0", "5.00", "0.5", etc.
    const validPattern = /^-?\d*\.?\d*$/;
    
    // Si el valor no coincide con el patrón válido, no actualizar
    if (inputValue !== "" && !validPattern.test(inputValue)) {
      // No actualizar el estado si el valor no es válido
      return;
    }
    
    // Permitir valores vacíos o parciales durante la escritura
    if (inputValue === "" || inputValue === "." || inputValue === "-") {
      this.setState({
        customValueToChargeString: inputValue,
        customValueToCharge: 0
      });
      return;
    }
    
    // Intentar parsear el valor, pero permitir valores parciales
    const numericValue = parseFloat(inputValue);
    
    // Si el valor no es un número válido pero tiene formato válido (ej: "5."), mantener el string
    if (isNaN(numericValue) && inputValue !== "") {
      // Permitir seguir escribiendo (ej: "5." se mantiene como "5.")
      this.setState({
        customValueToChargeString: inputValue
      });
      return;
    }
    
    // ✅ NO VALIDAR DURANTE LA ESCRITURA - Solo guardar el valor
    // La validación se hará en onBlur
    this.setState({
      customValueToChargeString: inputValue,
      value_to_charge: inputValue,
      valueToChargeConfirmed: inputValue,
      confirmedValueToCharge: inputValue,
      customValueToCharge: numericValue
    });
    
   /* console.log('📝 Custom value typing (no validation yet):', {
      inputValue,
      numericValue,
      maxValue: maxValue
    });*/
  };
  
  // ✅ NUEVO: Validar y aplicar el valor cuando el campo pierde el foco
  handleCustomValueBlur = (event, maxValue = null) => {
    const inputValue = event.target.value;
    
    // Si el campo está vacío, usar 0
    if (inputValue === "" || inputValue === "." || inputValue === "-") {
      const defaultValue = parseFloat(this.state.initialDisplayValueToCharge) || 0;
      this.setState({
        customValueToChargeString: defaultValue.toFixed(2),
        customValueToCharge: defaultValue,
        partial: defaultValue,
        value_to_charge: defaultValue.toFixed(2),
        valueToChargeConfirmed: defaultValue,
        confirmedValueToCharge: defaultValue
      });
      return;
    }
    
    const numericValue = parseFloat(inputValue) || 0;
    
    // ✅ VALIDAR SOLO CUANDO EL CAMPO PIERDE EL FOCO
    if (maxValue !== null) {
      const maxAmount = parseFloat(maxValue) || 0;
      if (numericValue > maxAmount) {
       // console.log('⚠️ Custom value exceeds maximum:', { numericValue, maxAmount });
        this.showStyledNotification(`El monto personalizado no puede exceder €${maxAmount}`, 'warning');
        
        // Restaurar al valor máximo permitido
        this.setState({
          customValueToChargeString: maxAmount.toFixed(2),
          customValueToCharge: maxAmount,
          partial: maxAmount,
          value_to_charge: maxAmount.toFixed(2),
          valueToChargeConfirmed: maxAmount,
          confirmedValueToCharge: maxAmount
        });
        return;
      }
    }
    
    // ✅ APLICAR EL VALOR VALIDADO
    this.setState({
      customValueToChargeString: numericValue.toFixed(2),
      customValueToCharge: numericValue,
      partial: numericValue,
      value_to_charge: numericValue.toFixed(2),
      valueToChargeConfirmed: numericValue,
      confirmedValueToCharge: numericValue
    });
    
  /*  console.log('✅ Custom value validated and applied:', {
      numericValue,
      maxValue: maxValue
    });*/
  };

  // Método helper para mostrar notificaciones personalizadas con colores
  showStyledNotification = (message, type = 'info', duration = null) => {
    // Usar el sistema global de notificaciones personalizadas
    if (window.customNotifications) {
      const config = {
        success: { duration: 4000, color: '#4caf50' },
        error: { duration: 6000, color: '#f44336' },
        warning: { duration: 5000, color: '#ff9800' },
        info: { duration: 4000, color: '#2196f3' }
      };
      
      const notificationConfig = config[type] || config.info;
      
      window.customNotifications.showNotification(
        message, 
        type, 
        duration || notificationConfig.duration
      );
    } else {
      // Fallback a react-admin si no está disponible el sistema personalizado
      this.props.showNotification(message, type, { duration });
    }
  };

  handleSubmit = async () => {
    const {
      rental,
      vehicleId,
      gpsDeviceId,
      valueToChargeConfirmed,
      effectiveDays,
      r_single,
      r_gps,
      r_insurance,
      r_cancel_insurance,
      low_seat,
      vehicle_model_1,
      rewards,
      value_to_charge,
      noConfirmationEmail,
      priceDate,
      cancelInsuranceValue,
      checkedF,
      discount,
      imt_comment,
      chargeTypeId,     
      isPendingTour,
      confirmedValueToCharge,
      isValueConfirmed,
      imt_commentN,
      extra_comments,
      r_documentacion,
      chargeSuplement,
      refund_value,
      chargeId,rentalTotal,
      partial,
      resend,
      sendFinalConfirmation, pricingBreakdown,
      invoice_comments,
      vehicles,
      gpsDevices,
      tourPrices,
      gpsPrices,
      insurancePrices,
      models,
      model1Price,
      model2Price,
      cancelInsurancePercentage
    } = this.state;
//console.log('this.state', this.state)
    this.setState({ isOnSubmit: true });

    const errors = this.validateForm();

    if (errors.length > 0) {
      var message = "Please fix the following errors:";
      errors.forEach(error => {
        message += "\n- " + error;
      });
      this.showStyledNotification(message, "error", 10000);
      this.setState({ isOnSubmit: false });
      return;
    }
    // Validar pago parcial antes de enviar
    if (this.partialPaymentNotOk()) {
      this.showStyledNotification("Partial payment cannot exceed the value to be charged!", "error");
      this.setState({ isOnSubmit: false });
      return;
    }

    try {
      // ✅ CORRECCIÓN: Calcular rentalTotalSubmit usando la MISMA LÓGICA que processTourEdit.js
      // En processTourEdit.js:
      // cancelInsuranceValue1 = r_cancel_insurance ? ((tourTotal1 + gpsPrice * efectiveDays + passengerPrice + singlePrice + model1Price) * cancelInsurancePercentage) / 100 : 0
      // rentalTotal1 = cancelInsuranceValue1 + (tourTotal1 + gpsPrice * efectiveDays + vipInsurancePrice * efectiveDays + passengerPrice + singlePrice + model1Price) - rewards
      // NOTA: NO incluye discount en rentalTotalSubmit, solo resta rewards
      // NOTA: La base del seguro de cancelación NO incluye vipInsurancePrice ni low_seat
      
      // Calcular usando los valores ACTUALES del estado (reflejando los toggles actuales)
      const effectiveDaysCalc = effectiveDays || this.calculateEffectiveDays(rental);
      const tourBasePriceCalc1 = this.getTourBasePrice(tourPrices, models.find(m => m.id === rental.booking.vehicle_model_1).model_name === "Own Motorcycle");
      const tourBasePriceCalc2 = this.getTourBasePrice(tourPrices, models.find(m => m.id === rental.booking.vehicle_model_2).model_name === "Own Motorcycle");
      const passengerPriceCalc = this.calculatePassengerPrice(rental, tourPrices, effectiveDaysCalc);
      const vehiclePriceCalc = this.calculateVehiclePrice(rental, tourPrices, models);
      
      // ✅ USAR LOS VALORES ACTUALES DEL ESTADO (no los del rental)
      const gpsPriceCalc = this.calculateGPSPriceWithState(gpsPrices, effectiveDaysCalc);
      const vipInsurancePriceCalc = this.calculateVIPInsurancePriceWithState(insurancePrices, effectiveDaysCalc);
      const singlePriceCalc = this.calculateSingleRoomPriceWithState(tourPrices);
      const lowSeatPriceCalc = this.calculateLowSeatPriceWithState(tourPrices);
      const pendingSupplementsCalc = this.calculatePendingSupplements(rental);
      
      // ✅ CALCULAR cancelInsurancePrice SIGUIENDO LA LÓGICA EXACTA DE processTourEdit.js
      // La base NO incluye vipInsurancePrice ni low_seat (solo tourTotal, gps, passenger, single, model1)
      const cancelInsuranceBaseCalc = tourBasePriceCalc1 + 
                                      passengerPriceCalc + 
                                      vehiclePriceCalc + 
                                      gpsPriceCalc + 
                                      singlePriceCalc;
      
      // Calcular cancelInsurancePrice usando la función que respeta el estado actual
      const cancelInsurancePriceCalc = this.calculateCancelInsurancePriceWithState(insurancePrices, cancelInsuranceBaseCalc);
      
      // ✅ SIGUIENDO LA LÓGICA EXACTA DE processTourEdit.js:
      // rentalTotal1 = cancelInsuranceValue1 + (tourTotal1 + gpsPrice * efectiveDays + vipInsurancePrice * efectiveDays + passengerPrice + singlePrice + model1Price) - rewards
      // NOTA: En processTourEdit.js:
      // - tourTotal1 = tourBasePriceCalc (precio base del tour)
      // - model1Price = vehiclePriceCalc (precio del vehículo)
      // - cancelInsuranceValue1 = cancelInsurancePriceCalc (ya calculado)
      // - gpsPrice * efectiveDays = gpsPriceCalc (ya incluye la multiplicación)
      // - vipInsurancePrice * efectiveDays = vipInsurancePriceCalc (ya incluye la multiplicación)
      
      // Calcular el subtotal del tour (sin cancelInsurance, que se suma después)
      const tourSubtotal = tourBasePriceCalc1 + 
                          gpsPriceCalc + 
                          vipInsurancePriceCalc + 
                          passengerPriceCalc + 
                          singlePriceCalc + 
                          vehiclePriceCalc + 
                          pendingSupplementsCalc + 
                          lowSeatPriceCalc;
      
      // ✅ CALCULAR rentalTotalSubmit SIGUIENDO LA LÓGICA EXACTA DE processTourEdit.js
      // rentalTotalSubmit = cancelInsurancePrice + (tourSubtotal) - rewards
      // NOTA: NO se resta discount, solo rewards (como en processTourEdit.js)
      const rentalTotalSubmit = cancelInsurancePriceCalc + tourSubtotal - (rewards || 0);
      
     /* console.log('💰 Calculando rentalTotalSubmit para envío (siguiendo lógica de processTourEdit.js):', {
        // Base para cancelInsurance (NO incluye VIP ni low_seat)
        cancelInsuranceBaseCalc,
        cancelInsurancePriceCalc,
        // Componentes del tour
        tourBasePriceCalc,
        gpsPriceCalc,
        vipInsurancePriceCalc,
        passengerPriceCalc,
        singlePriceCalc,
        vehiclePriceCalc,
        pendingSupplementsCalc,
        lowSeatPriceCalc,
        // Totales
        tourSubtotal,
        rewards: rewards || 0,
        rentalTotalSubmit,
        // Estado de toggles
        r_insurance,
        r_gps,
        r_single,
        r_cancel_insurance,
        discount, // NO se usa en el cálculo, solo para referencia
        effectiveDaysCalc
      });*/
      
      // Calcular todos los precios y datos detallados
      const pricingData = await this.calculateAllPricingData();
      
      // Preparar datos para el endpoint refactorizado
      const tourData = {
        // Datos básicos del tour
        p4m: rental.booking && rental.booking.p4m === true ? true : false, // Asegurar que siempre sea un booleano
        from_agency: rental.from_agency === true ? true : false, // Asegurar que siempre sea un booleano
        driver_id: rental.client_id,
        effectiveDays: effectiveDays,
        discount,
        vehicle_id: vehicleId,
        date_1: rental.date_1,
        date_2: rental.date_2,
        time_1: rental.time_1,
        time_2: rental.time_2,
        location_id_1: rental.location_id_1,
        location_id_2: rental.location_id_2,
        charge_type_id: chargeTypeId,
        comments: rental.booking.r_comments,
        // ✅ CORRECCIÓN: Usar imt_commentN si está disponible, sino usar imt_comment
        imt_comment: imt_commentN || imt_comment || "",
        gpsdevice_id: gpsDeviceId,
        r_insurance: isPaidInsurance(this.state.r_insurance_id),
        r_insurance_id: normalizeInsuranceId(this.state.r_insurance_id),
        rewards,
        // ✅ CORRECCIÓN: K1600GT no debe permitir GPS, forzar a false
        r_gps: this.getModelName1() === "K1600GT" ? false : (r_gps === true),
        low_seat: low_seat === true,
        // ✅ Asegurar que r_single se envíe correctamente
        r_single: r_single === true,
        vehicle_model_1: vehicle_model_1,
        // ✅ Asegurar que r_cancel_insurance se envíe correctamente
        r_cancel_insurance: r_cancel_insurance === true,
        value_to_charge: isValueConfirmed ? confirmedValueToCharge : value_to_charge,
        noConfirmationEmail,
        priceDate,
        // Use freshly calculated cancel insurance (not stale state, which can be negative/corrupt)
        cancelInsuranceValue: Math.max(
          0,
          Number(
            (pricingData && pricingData.cancelInsuranceValue) != null
              ? pricingData.cancelInsuranceValue
              : cancelInsurancePriceCalc
          ) || 0
        ),
        checkedF,
        partial,
        resend,
        sendFinalConfirmation,
        invoice_comments,
        // ✅ ENVIAR EL rentalTotalSubmit CALCULADO CON LOS VALORES ACTUALES
        rentalTotalSubmit: rentalTotalSubmit,
        // VEHÍCULO SELECCIONADO con información completa
        selected_vehicle: pricingData.selectedVehicle ? {
          id: pricingData.selectedVehicle.id,
          vehicle_model_id: pricingData.selectedVehicle.vehicle_model_id,
          vehicle_model_name: this.getModelName1(),
          licence_plate: pricingData.selectedVehicle.licence_plate || "",
          vehicle_color: pricingData.selectedVehicle.vehicle_color || "",
          vehicle_year: pricingData.selectedVehicle.vehicle_year || "",
          vehicle_mileage: pricingData.selectedVehicle.vehicle_mileage || "",
          vehicle_chassis: pricingData.selectedVehicle.vechicle_chassis || "",
          vehicle_options: pricingData.selectedVehicle.vehicle_options || "",
          vehicle_price: pricingData.model1Price
        } : {
          id: 0,
          vehicle_model_id: 2,
          vehicle_model_name: '',
          licence_plate:  "",
          vehicle_color:  "",
          vehicle_year:  "",
          vehicle_mileage: "",
          vehicle_chassis: "",
          vehicle_options: "",
          vehicle_price: 0
        },
          
        // GPS SELECCIONADO (si fue seleccionado)
        selected_gps: pricingData.selectedGpsDevice ? {
          id: pricingData.selectedGpsDevice.id,
          device_name: pricingData.selectedGpsDevice.device_name || "",
          device_model: pricingData.selectedGpsDevice.device_model || "",
          gps_price_per_day: pricingData.gpsPrice,
          gps_total_price: pricingData.gpsTotalPrice
        } : null,
          
        // OPCIONES SELECCIONADAS con sus montos individuales
        selected_options: {
          // Opción de habitación
          room_option: {
            type: r_single ? "single" : "double",
            selected: r_single || !r_single,
            price: pricingData.singlePrice,
            total_price: r_single ? pricingData.singlePrice : 0
          },
            
          // Opción de GPS
          gps_option: {
            selected: r_gps,
            price_per_day: pricingData.gpsPrice,
            total_price: pricingData.gpsTotalPrice,
            device_id: gpsDeviceId
          },
            
          // Opción de seguro VIP
          vip_insurance_option: {
            selected: r_insurance,
            price_per_day: pricingData.vipInsurancePrice,
            total_price: pricingData.vipInsuranceTotal
          },
            
          // Opción de seguro de cancelación
          cancel_insurance_option: {
            selected: r_cancel_insurance,
            percentage: pricingData.cancelInsurancePercentage,
            total_price: pricingData.cancelInsuranceValue
          },
            
          // Opción de asiento bajo
          low_seat_option: {
            selected: low_seat,
            price: pricingData.lowSeatPrice
          }
        },
          
        // DESGLOSE COMPLETO DE PRECIOS
        pricing_breakdown: {
          // Precios base
          tour_total_price: pricingData.tourTotal1,
          tour_passenger_price: pricingData.passengerPrice,
          vehicle_model_price: pricingData.model1Price,
            
          // Precios de opciones
          single_room_price: pricingData.singlePrice,
          gps_total_price: pricingData.gpsTotalPrice,
          vip_insurance_total: pricingData.vipInsuranceTotal,
          cancel_insurance_total: pricingData.cancelInsuranceValue,
          low_seat_price: pricingData.lowSeatPrice,
            
          // Descuentos y recompensas
          discount_amount: discount,
          rewards_amount: rewards,
            
          // Total calculado
          subtotal: pricingData.subtotal,
          cancel_insurance_amount: pricingData.cancelInsuranceValue,
          final_total: value_to_charge,
            
          // Días efectivos
          effective_days: pricingData.effectiveDays
        },
        
        // Campos adicionales para tours ya procesados
        ...(isPendingTour ? {
          valueToChargeConfirmed,
          partial,
        } : {
          imt_commentN,
          extra_comments,
          r_documentacion,
          chargeSuplement,
          refund_value,
          chargeId,
          valueToChargeConfirmed,
          partial,
          resend,
          sendFinalConfirmation,
          invoice_comments
        })
      };

    
      // Usar el servicio refactorizado para procesar/actualizar el tour
      const result = await this.processTourWithRefactoredService(tourData);
      
    
      this.showStyledNotification("Tour processed successfully!", "success");
      if (isPendingTour) {
        this.props.history.replace("/tour-management");
      } else {
        this.props.history.replace("/tour_due_list");
      }
      
    } catch (error) {
    
      this.setState({ isOnSubmit: false });
      console.log('Error processing tour:', error.details);
      
      // Construir mensaje completo con el mensaje principal y los detalles
      let fullErrorMessage = error.message || "Error processing tour";
      
      if (error.details && Array.isArray(error.details) && error.details.length > 0) {
        const detailsMessages = error.details.map(detail => detail.message).join('; ');
        fullErrorMessage = `${fullErrorMessage}\n${detailsMessages}`;
      }
      
      this.showStyledNotification(fullErrorMessage, "error", 8000);
    }
  };

  // Método para calcular todos los precios y datos detallados
  calculateAllPricingData = async () => {
    const { rental, tourPrices, gpsPrices, insurancePrices, models, vehicles, gpsDevices, vehicleId, gpsDeviceId } = this.state;
    
    if (!rental) {
      throw new Error("No rental data available");
    }
    
    // Usar la función principal de cálculo
    const pricingCalculation = this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
    
    // Obtener vehículo y GPS seleccionados
    const selectedVehicle = vehicles.find(v => v.id === vehicleId);
    const selectedGpsDevice = gpsDevices.find(g => g.id === gpsDeviceId);
    
    return {
      selectedVehicle,
      selectedGpsDevice,
      singlePrice: pricingCalculation.breakdown.singleRoomPrice,
      gpsPrice: pricingCalculation.breakdown.gpsPrice / pricingCalculation.effectiveDays, // Precio por día
      gpsTotalPrice: pricingCalculation.breakdown.gpsPrice,
      vipInsurancePrice: pricingCalculation.breakdown.vipInsurancePrice / pricingCalculation.effectiveDays, // Precio por día
      vipInsuranceTotal: pricingCalculation.breakdown.vipInsurancePrice,
      lowSeatPrice: 0, // TODO: Implementar cálculo de low_seat
      tourTotal1: pricingCalculation.totalValue,
      passengerPrice: pricingCalculation.breakdown.passengerPrice,
      model1Price: pricingCalculation.breakdown.vehiclePrice,
      cancelInsurancePercentage: this.state.cancelInsurancePercentage || 0,
      cancelInsuranceValue: pricingCalculation.breakdown.cancelInsurancePrice,
      effectiveDays: pricingCalculation.effectiveDays,
      subtotal: pricingCalculation.totalValue
    };
  };

  // Validation
  rewardsNotOk = () => {
    const { rewards, clientRewards, rental } = this.state;
    
    // Si no hay rewards solicitados, no hay problema
    if (!rewards || parseInt(rewards, 0) === 0) {
      return false;
    }
    
    // Para tours ya procesados, verificar si los rewards ya fueron asignados al tour
    if (rental && rental.booking && rental.booking.reward_used) {
      // Si los rewards ya fueron usados en este tour, permitir el mismo valor
      const tourRewards = parseInt(rental.booking.rewards, 0) || 0;
      const requestedRewards = parseInt(rewards, 0);
      
      // Permitir si los rewards solicitados son iguales o menores a los ya asignados al tour
      if (requestedRewards <= tourRewards) {
        return false;
      }
    }
    
    // ✅ Validar contra rewards disponibles (clientRewards nunca debe ser negativo)
    const rewardsAvailable = Math.max(0, clientRewards);
    const rewardsRequested = parseInt(rewards, 0);
    const isNotOk = rewardsRequested > rewardsAvailable;
    
/*     console.log('🔍 Validación de rewards:', {
      rewardsRequested: rewardsRequested,
      clientRewards: clientRewards,
      rewardsAvailable: rewardsAvailable,
      isNotOk: isNotOk
    }); */
    
    return isNotOk;
  };

  // Validar que el pago parcial no exceda el valor a cobrar
  partialPaymentNotOk = () => {
    const { partial, value_to_charge } = this.state;
    return parseFloat(partial) > parseFloat(value_to_charge);
  };

  /**
   * Estado a limpiar cuando el precio del tour cambia tras haber confirmado el cobro.
   * Obliga al usuario a revisar y volver a confirmar el valor a cobrar.
   */
  getChargeConfirmationResetState = () => ({
    checkedF: false,
    customValueEnabled: false,
    isValueConfirmed: false,
    customValueToCharge: 0,
    customValueToChargeString: '',
    initialDisplayValueToCharge: 0,
    confirmedValueToCharge: 0,
  });

  shouldInvalidateChargeConfirmation = () =>
    !!(this.state.isValueConfirmed || this.state.checkedF);

  notifyChargeConfirmationInvalidated = () => {
    this.showStyledNotification(
      'Tour price changed. Please confirm the value to be charged again.',
      'warning'
    );
  };

  /**
   * Recalcula el valor total del tour cuando cambian las opciones (GPS, seguro, habitación, etc.)
   * Esta función resetea currentValueToCharge para forzar un nuevo cálculo
   */
  recalcularValorTotalTour = async () => {
    const shouldInvalidate = this.shouldInvalidateChargeConfirmation();
    // Resetear currentValueToCharge para forzar nuevo cálculo y permitir recalcular el value_to_charge
    this.setState({
      currentValueToCharge: 0,
      valueToChargeCalculatedByUpdatePricing: false,
      ...(shouldInvalidate ? this.getChargeConfirmationResetState() : {}),
    }, () => {
      if (shouldInvalidate) {
        this.notifyChargeConfirmationInvalidated();
      }
      // Llamar a recalcularValueToCharge que detectará que currentValueToCharge es 0
      this.updatePricingBreakdown();
    });
  };

  // Métodos para recálculo de precios usando funciones auxiliares
  async getValueTobeChargeSingle() {
    const { rental, tourPrices } = this.state;
    
    if (!rental) return;

    const singlePrice = this.calculateSingleRoomPrice(rental, tourPrices);

    if (this.state.r_single && !this.state.notifications.single) {
      let mensaje = `Single room added: € ${singlePrice}`;
      if (!isNaN(singlePrice)) {
        this.setState(prevState => ({
          notifications: {
            ...prevState.notifications,
            single: true
          }
        }));
        this.showStyledNotification(mensaje, 'success');
      }
    } else if (!this.state.r_single) {
      this.setState(prevState => ({
        notifications: {
          ...prevState.notifications,
          single: false
        }
      }));
    }
    this.recalcularSeguroCancelacion();
  }

  async recalcularSeguroCancelacion() {
    const { rental, tourPrices, gpsPrices, insurancePrices, models } = this.state;
    
    if (!rental) return;

    // Usar funciones auxiliares para calcular componentes
    const effectiveDays = this.calculateEffectiveDays(rental);
    const tourBasePrice1 = this.getTourBasePrice(tourPrices, models.find(m => m.id === this.state.vehicle_model_1).model_name === "Own Motorcycle");
    const tourBasePrice2 = this.getTourBasePrice(tourPrices, models.find(m => m.id === this.state.vehicle_model_2).model_name === "Own Motorcycle");
    const passengerPrice = this.calculatePassengerPrice(rental, tourPrices, effectiveDays);
    const vehiclePrice = this.calculateVehiclePrice(rental, tourPrices, models);
    const gpsPrice = this.calculateGPSPrice(rental, gpsPrices, effectiveDays);
    const singlePrice = this.calculateSingleRoomPrice(rental, tourPrices);
    
    // Calcular base para seguro de cancelación
    const cancelInsuranceBase = tourBasePrice1 + passengerPrice + vehiclePrice + gpsPrice + singlePrice;
    const cancelInsuranceValue = this.calculateCancelInsurancePrice(rental, insurancePrices, cancelInsuranceBase);
    
    // Obtener porcentaje de seguro de cancelación
    const cancelInsurance = insurancePrices.find(p => p.price_item_type === "insurance" && p.price_item_id === 3);
    const cancelInsurancePercentage = cancelInsurance ? cancelInsurance.percentage : 0;

    this.setState({
      cancelInsuranceValue: Math.max(0, Number(cancelInsuranceValue) || 0),
      cancelInsurancePercentage,
      // PRESERVAR el estado vehicles para evitar que se pierda
      vehicles: this.state.vehicles,
      gpsDevices: this.state.gpsDevices
    });

    // Recalcular value_to_charge
    this.recalcularValueToCharge();
    
    // Actualizar el desglose de precios en el estado
    this.updatePricingBreakdown();
  }
  
  // Método para actualizar el desglose de precios en el estado
  updatePricingBreakdown = async () => {
    try {
      const { rental, tourPrices, gpsPrices, insurancePrices, models, r_gps, r_insurance, r_single, r_cancel_insurance, low_seat } = this.state;
      
      if (!rental) {
        console.warn('⚠️ updatePricingBreakdown: No rental data available');
        return;
      }
      
      // Calcular días efectivos PRIMERO - es crítico para todos los cálculos
      const effectiveDays = this.calculateEffectiveDays(rental);
      
      if (!effectiveDays || effectiveDays <= 0) {
        console.warn('⚠️ updatePricingBreakdown: Invalid effectiveDays:', effectiveDays);
      }
      
      // Validar que gpsPrices esté disponible si r_gps está activado
      if (r_gps && (!gpsPrices || (Array.isArray(gpsPrices) && gpsPrices.length === 0) || (gpsPrices.data && gpsPrices.data.length === 0))) {
        console.warn('⚠️ updatePricingBreakdown: GPS enabled but no GPS prices available', { r_gps, gpsPrices });
      }
      
      // Usar la función principal de cálculo
      const pricingCalculation = this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
      var tourBasePrice1 = 0;
      var tourBasePrice2 = 0;
      // Calcular precios individuales para mostrar en el UI usando el mismo effectiveDays
      
       tourBasePrice1 = this.getTourBasePrice(tourPrices, models.find(m => m.id === this.state.vehicle_model_1).model_name === "Own Motorcycle");
       tourBasePrice2 = this.getTourBasePrice(tourPrices, models.find(m => m.id === this.state.vehicle_model_2).model_name === "Own Motorcycle");
      const passengerPrice = this.calculatePassengerPrice(rental, tourPrices, effectiveDays);
      const vehiclePrice = this.calculateVehiclePrice(rental, tourPrices, models);
      
      const vehiclePrice2 = this.calculateVehicle2Price(rental, tourPrices, models);

      // ✅ USAR EL ESTADO ACTUAL DEL COMPONENTE EN LUGAR DE LOS DATOS DEL RENTAL
      const gpsPrice = this.calculateGPSPriceWithState(gpsPrices, effectiveDays);
      const vipInsurancePrice = this.calculateVIPInsurancePriceWithState(insurancePrices, effectiveDays);
      const singlePrice = this.calculateSingleRoomPriceWithState(tourPrices);
      const cancelInsurancePrice = this.calculateCancelInsurancePriceWithState(insurancePrices, tourBasePrice1 + passengerPrice + vehiclePrice + gpsPrice + singlePrice);
      const pendingSupplements = this.calculatePendingSupplements(rental);
      
      // Calcular low_seat si existe
      const lowSeatPrice = this.calculateLowSeatPriceWithState(tourPrices);
      
      // ✅ USAR LOS VALORES DEL ESTADO ACTUAL DEL COMPONENTE
      const discount = this.state.discount || 0;
      const rewards = this.state.rewards || 0;
      
      // Debug: Log para verificar valores cuando GPS está activado
      if (r_gps) {
      /*  console.log('📊 GPS Calculation Debug:', {
          r_gps,
          effectiveDays,
          gpsPrices: gpsPrices ? (Array.isArray(gpsPrices) ? gpsPrices.length : (gpsPrices.data ? gpsPrices.data.length : 0)) : 0,
          gpsPrice,
          gpsPricePerDay: effectiveDays > 0 ? gpsPrice / effectiveDays : 0
        });*/
      }
/*       console.log('💰 Valores de descuento y recompensas:', {
        discount: discount,
        rewards: rewards,
        stateDiscount: this.state.discount,
        stateRewards: this.state.rewards
      }); */
      // Calcular subtotal (sin descuentos ni recompensas)
      const subtotal = tourBasePrice1 + passengerPrice + vehiclePrice + gpsPrice + 
                      vipInsurancePrice + singlePrice + cancelInsurancePrice + 
                      pendingSupplements + lowSeatPrice;
/* console.log('tourBasePrice', tourBasePrice);
console.log('passengerPrice', passengerPrice);
console.log('vehiclePrice', vehiclePrice);
console.log('gpsPrice', gpsPrice);
console.log('vipInsurancePrice', vipInsurancePrice);
console.log('singlePrice', singlePrice);
console.log('cancelInsurancePrice', cancelInsurancePrice);
console.log('pendingSupplements', pendingSupplements);
 */
      const subtotal2 = tourBasePrice2 + passengerPrice + vehiclePrice2 + gpsPrice + 
                      vipInsurancePrice + singlePrice + cancelInsurancePrice + 
                      pendingSupplements + lowSeatPrice;

      
      // Calcular total final (con descuentos y recompensas)
      const finalTotal = subtotal - discount - rewards;
      const finalTotal2 = subtotal2 - discount - rewards;
      
      // ✅ CALCULAR EL VALUE_TO_CHARGE ÚNICAMENTE AQUÍ
      // CORRECCIÓN: Para tours pending, calcular el depósito según la lógica especificada
      let valueToCharge;
      let totalPaid = null; // Inicializar para usar en logs
      const { isPendingTour } = this.state;
      
      if (isPendingTour) {
        // Para tours pending: calcular depósito según la lógica de 60 días
        const effectiveStartDate = (rental.booking && rental.booking.tour && rental.booking.tour.effective_start_date) || 
                                   rental.effective_start_date || 
                                   rental.date_1;
        const dayActual = moment(Date.now()).format("YYYY-MM-DD");
        const rentalAheadSixtyDays = moment(effectiveStartDate).diff(dayActual, "days") >= 60;
        
        // Calcular depósito base: 500 + 500 si tiene pasajero
        let depositToCharge = rentalAheadSixtyDays ? 500 + (passengerPrice > 0 ? 500 : 0) : 0;
        
        // Agregar seguro de cancelación si existe
        if (this.state.r_cancel_insurance && cancelInsurancePrice > 0) {
          depositToCharge += cancelInsurancePrice;
        }
        
        // Si está a menos de 60 días, cobrar la cantidad entera
        // Usar la misma lógica que en la carga inicial: cancelInsurance + (tour + gps + vip + passenger + single + ownMotorcycle)
        if (moment(effectiveStartDate).diff(Date.now(), "days") < 60) {
          // Obtener el modelo seleccionado para verificar si es "Own Motorcycle"
          const selectedModel = models.find(m => m.id === this.state.vehicle_model_1);
          const ownMotorcycleFee = selectedModel && selectedModel.model_name === "Own Motorcycle" ? 500 : 0;
          
          // Para "Own Motorcycle", usar tourPassengerPrice * effectiveDays en lugar de tourBasePrice
          // (igual que en la carga inicial, línea 842)
          // Obtener tourPassengerPrice desde tourPrices
          const tourPassengerPriceItem = tourPrices.find(p => p.price_item_sub_type === "tour_passenger");
          const tourPassengerPricePerDay = tourPassengerPriceItem ? tourPassengerPriceItem.price : 0;
          const tourPriceForDeposit = selectedModel && selectedModel.model_name === "Own Motorcycle" 
            ? tourPassengerPricePerDay  // Para Own Motorcycle, usar tourPassengerPrice * days
            : tourBasePrice1;
          
          // Calcular rentalTotal1 igual que en la carga inicial (sin low_seat ni pendingSupplements)
          // Nota: passengerPrice se suma siempre (incluso para Own Motorcycle), según la lógica original
          const rentalTotal1ForDeposit = cancelInsurancePrice + 
            (tourPriceForDeposit + passengerPrice + vehiclePrice + gpsPrice + vipInsurancePrice + singlePrice + ownMotorcycleFee);
          depositToCharge = rentalTotal1ForDeposit;
        }
        
        valueToCharge = depositToCharge;
      } else {
        // Para tours procesados: usar la lógica original
        totalPaid = this.calculateTotalPaid(rental);
       // console.log('totalPaid line 2487', totalPaid.totalPaid);
        const netPaid =
          (totalPaid.totalPaid || 0) - (totalPaid.totalRefunded || 0);
        valueToCharge = Math.max(0, finalTotal - netPaid);
      }
      //console.log('valueToCharge line 2490', valueToCharge);
      // ✅ DEBUG: Log detallado del cálculo cuando hay cambios
      if (r_gps || r_insurance || r_single || r_cancel_insurance || low_seat) {
       /* console.log('💰 Cálculo detallado del value_to_charge:', {
          // Componentes del subtotal
          tourBasePrice,
          passengerPrice,
          vehiclePrice,
          gpsPrice,
          vipInsurancePrice,
          singlePrice,
          cancelInsurancePrice,
          lowSeatPrice,
          pendingSupplements,
          // Totales
          subtotal,
          discount,
          rewards,
          finalTotal,
          // Pagos y valor a cargar
          totalPaid: totalPaid ? totalPaid.totalPaid : 0,
          totalRefunded: totalPaid ? totalPaid.totalRefunded : 0,
          valueToCharge,
          // Estado de toggles
          r_gps,
          r_insurance,
          r_single,
          r_cancel_insurance,
          low_seat,
          // Días efectivos
          effectiveDays
        });*/
      }
      this.setState({
        // ✅ USAR EL effectiveDays CALCULADO LOCALMENTE (no el de pricingCalculation)
        effectiveDays: effectiveDays,
        // ✅ ÚNICA FUENTE DE VERDAD PARA value_to_charge
        value_to_charge: valueToCharge.toFixed(2),
        valueToChargeConfirmed: valueToCharge.toFixed(2),
        customValueToCharge: valueToCharge.toFixed(2),
        // Keep cancelInsuranceValue in sync with pricingBreakdown (avoid stale/negative payload)
        cancelInsuranceValue: Math.max(0, Number(cancelInsurancePrice) || 0),
        // Marcar que el value_to_charge ha sido calculado por updatePricingBreakdown
        valueToChargeCalculatedByUpdatePricing: true,
        pricingBreakdown: {
          tour_total: tourBasePrice1,
          tour_total2: tourBasePrice2,
          vehicle_model: vehiclePrice,
          vehicle_model_2: vehiclePrice2,
          single_room: singlePrice,
          gps_total: gpsPrice, // ✅ Esto debería tener el valor correcto cuando r_gps está activado
          vip_insurance: vipInsurancePrice,
          cancel_insurance: cancelInsurancePrice,
          low_seat: lowSeatPrice,
          passenger_price: passengerPrice,
          pending_supplements: pendingSupplements,
          discount: discount,
          rewards: rewards,
          subtotal: subtotal,
          final_total: finalTotal,
          subtotal2: subtotal2, 
          final_total2: finalTotal2
        },
        // PRESERVAR el estado vehicles para evitar que se pierda
        vehicles: this.state.vehicles,
        gpsDevices: this.state.gpsDevices
      });
      
      // Debug: Verificar que el GPS se haya calculado correctamente
      if (r_gps || r_insurance || r_single) {
       /* console.log('✅ Pricing Breakdown Updated - State:', {
          r_gps,
          r_insurance,
          r_single,
          effectiveDays,
          gps_total: gpsPrice,
          vip_insurance: vipInsurancePrice,
          single_room: singlePrice,
          finalTotal,
          totalPaid: totalPaid ? totalPaid.totalPaid : 0,
          value_to_charge: valueToCharge.toFixed(2),
          valueToChargeCalculatedByUpdatePricing: true
        });*/
      }
      
     // console.log('✅ Pricing Breakdown actualizado - value_to_charge:', valueToCharge.toFixed(2));
      
    } catch (error) {
      console.error('❌ Error updating pricing breakdown:', error);
    }
  };

  /**
   * Calcula el precio del asiento bajo si está seleccionado
   */
  calculateLowSeatPrice(rental, tourPrices) {
    // Verificar si asiento bajo está activado en booking o si hay seat en items
    const hasLowSeat = (rental.booking && rental.booking.low_seat) ||
                      (rental.seat && rental.seat.length > 0) ||
                      (rental.low_seat === true);

    if (!hasLowSeat) {
      return 0;
    }

    // Buscar el precio del asiento bajo en tourPrices
    const lowSeatPrice = tourPrices.find(p => p.price_item_sub_type === "tour_low_seat");
    return lowSeatPrice ? lowSeatPrice.price : 0;
  }

  // ✅ NUEVAS FUNCIONES QUE USAN EL ESTADO ACTUAL DEL COMPONENTE

  /**
   * Calcula el precio del GPS usando el estado actual del componente
   */
  calculateGPSPriceWithState(gpsPrices, effectiveDays) {
    // ✅ USAR EL ESTADO ACTUAL r_gps EN LUGAR DE LOS DATOS DEL RENTAL
    const { r_gps } = this.state;
    
    if (!r_gps) {
     // console.log('📊 calculateGPSPriceWithState: r_gps is false, returning 0');
      return 0;
    }
    
    if (!effectiveDays || effectiveDays <= 0) {
    //  console.warn('⚠️ calculateGPSPriceWithState: Invalid effectiveDays:', effectiveDays);
      return 0;
    }

    // Normalizar gpsPrices a un array
    let priceList = [];
    if (Array.isArray(gpsPrices)) {
      priceList = gpsPrices;
    } else if (gpsPrices && Array.isArray(gpsPrices.data)) {
      priceList = gpsPrices.data;
    } else if (gpsPrices && gpsPrices.data && Array.isArray(gpsPrices.data)) {
      priceList = gpsPrices.data;
    }

    if (priceList.length === 0) {
    //  console.warn('⚠️ calculateGPSPriceWithState: No GPS prices found', { gpsPrices, priceList });
      return 0;
    }

    // Buscar el precio del GPS - puede estar en diferentes formatos
    const gpsPrice = priceList.find(p => 
      p.price_item_type === "gps_device" || 
      p.type === "gps_device" ||
      p.item_type === "gps_device"
    );
    
    if (!gpsPrice) {
     /* console.warn('⚠️ calculateGPSPriceWithState: GPS price item not found in list', { 
        priceList: priceList.map(p => ({ 
          id: p.id, 
          price_item_type: p.price_item_type, 
          type: p.type,
          price: p.price 
        }))
      });*/
      return 0;
    }

    // Extraer el precio por día - puede estar en diferentes campos
    const pricePerDay = parseFloat(
      gpsPrice.price || 
      gpsPrice.amount || 
      gpsPrice.value || 
      gpsPrice.price_per_day || 
      0
    );

    if (!pricePerDay || pricePerDay <= 0) {
    /*  console.warn('⚠️ calculateGPSPriceWithState: Invalid pricePerDay', { 
        gpsPrice, 
        pricePerDay 
      });*/
      return 0;
    }

    const totalGPSPrice = pricePerDay * effectiveDays;
    
  /*  console.log('✅ calculateGPSPriceWithState:', {
      r_gps,
      effectiveDays,
      pricePerDay,
      totalGPSPrice,
      gpsPriceItem: gpsPrice
    });*/

    return totalGPSPrice;
  }

  /**
   * Calcula el precio del seguro VIP usando el estado actual del componente
   */
  calculateVIPInsurancePriceWithState(insurancePrices, effectiveDays) {
    const applicableId = resolveApplicableInsuranceId(
      this.state.r_insurance_id,
      effectiveDays
    );
    const daily = dailyInsurancePriceFromList(insurancePrices, applicableId);
    return daily * (Number(effectiveDays) || 0);
  }

  /**
   * Calcula el precio de habitación individual usando el estado actual del componente
   */
  calculateSingleRoomPriceWithState(tourPrices) {
    // ✅ USAR EL ESTADO ACTUAL r_single EN LUGAR DE LOS DATOS DEL RENTAL
    const { r_single } = this.state;
    
    if (!r_single) {
      return 0;
    }

    const singlePrice = tourPrices.find(p => p.price_item_sub_type === "tour_single");
    return singlePrice ? singlePrice.price : 0;
  }

  /**
   * Calcula el seguro de cancelación usando el estado actual del componente
   */
  calculateCancelInsurancePriceWithState(insurancePrices, baseAmount) {
    // ✅ USAR EL ESTADO ACTUAL r_cancel_insurance EN LUGAR DE LOS DATOS DEL RENTAL
    const { r_cancel_insurance } = this.state;
    
    if (!r_cancel_insurance) {
      return 0;
    }

    const cancelInsurance = insurancePrices.find(p => p.price_item_type === "insurance" && p.price_item_id === 3);
    if (!cancelInsurance) {
      return 0;
    }

    const percentage = cancelInsurance.percentage || 7.5; // Default 7.5%
    return (baseAmount * percentage) / 100;
  }

  /**
   * Calcula el precio del asiento bajo usando el estado actual del componente
   */
  calculateLowSeatPriceWithState(tourPrices) {
    // ✅ USAR EL ESTADO ACTUAL low_seat EN LUGAR DE LOS DATOS DEL RENTAL
    const { low_seat } = this.state;
    
    if (!low_seat) {
      return 0;
    }

    // Buscar el precio del asiento bajo en tourPrices
    const lowSeatPrice = tourPrices.find(p => p.price_item_sub_type === "tour_low_seat");
    return lowSeatPrice ? lowSeatPrice.price : 0;
  }

  // Refactorizar recalcularValueToCharge para usar funciones auxiliares
  async recalcularValueToCharge() {
    const { rental, tourPrices, gpsPrices, insurancePrices, models, currentValueToCharge, valueToChargeCalculatedByUpdatePricing } = this.state;

    if (!rental) {
      return;
    }

    // ✅ NO SOBRESCRIBIR value_to_charge SI YA FUE CALCULADO POR updatePricingBreakdown
    if (valueToChargeCalculatedByUpdatePricing) {
     // console.log('🛡️ value_to_charge protegido - ya calculado por updatePricingBreakdown');
      return;
    }

    // Si currentValueToCharge es 0 o no existe, calcular el valor total del tour
    let tourTotalResult;
    if (!currentValueToCharge || currentValueToCharge === 0) {
      tourTotalResult = this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
      
      // Actualizar currentValueToCharge en el estado
      this.setState({
        currentValueToCharge: tourTotalResult.totalValue,
        effectiveDays: tourTotalResult.effectiveDays,
        tourTotal: tourTotalResult.breakdown.tourBasePrice,
        passengerPrice: tourTotalResult.breakdown.passengerPrice,
        model1Price: tourTotalResult.breakdown.vehiclePrice,
        gpsPrice: tourTotalResult.breakdown.gpsPrice,
        vipInsurancePrice: tourTotalResult.breakdown.vipInsurancePrice,
        singlePrice: tourTotalResult.breakdown.singleRoomPrice,
        pendingSupplements: tourTotalResult.breakdown.pendingSupplements
      });
    } else {
      tourTotalResult = {
        totalValue: currentValueToCharge,
        effectiveDays: this.state.effectiveDays,
        valueToCharge: this.state.value_to_charge
      };
    }

    // Calcular value_to_charge basado en currentValueToCharge y charges
    const valueToChargeResult = this.calculateValueToCharge(rental, tourTotalResult.totalValue);
    
    // Actualizar el estado con los nuevos valores (SIN SOBRESCRIBIR value_to_charge)
    this.setState({
      // ❌ NO ACTUALIZAR value_to_charge - ya está calculado por updatePricingBreakdown
      // value_to_charge: this.state.isValueConfirmed ? this.state.confirmedValueToCharge : valueToChargeResult.valueToCharge.toFixed(2),
      // valueToChargeConfirmed: valueToChargeResult.valueToCharge.toFixed(2),
      // customValueToCharge: valueToChargeResult.valueToCharge.toFixed(2),
      rentalTotal: tourTotalResult.totalValue,
      firstChoiceTotal: tourTotalResult.totalValue,
      secondChoiceTotal: tourTotalResult.totalValue + (this.state.model2Price || 0) - (this.state.model1Price || 0),
      // CORRECCIÓN: Actualizar rentalTotal1 y rentalTotal2 que se usan en el render
      rentalTotal1: tourTotalResult.totalValue,
      rentalTotal2: tourTotalResult.totalValue + (this.state.model2Price || 0) - (this.state.model1Price || 0)
    });
  }

        
  // ========================================
  // FUNCIONES AUXILIARES REUTILIZABLES
  // ========================================

  /**
   * Función principal para calcular todos los precios del tour
   * Reemplaza todas las funciones duplicadas anteriores
   */
  calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models) {
    // Calcular valor total del tour
    const tourCalculation = this.calculateTotalTourValue(rental, tourPrices, gpsPrices, insurancePrices, models);
    
    // Calcular valor a cobrar
    const chargeCalculation = this.calculateValueToCharge(rental, tourCalculation.totalValue);
    
    return {
      ...tourCalculation,
      ...chargeCalculation
    };
  }

  /**
   * Función simplificada para compatibilidad con código existente
   */
  calcularValorTotalTour = (rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) => {
    return this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
  };
  
  /**
   * Función simplificada para compatibilidad con código existente
   */
  calcularCostoTotalRental = (rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) => {
    return this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
  };

  /**
   * Función simplificada para compatibilidad con código existente
   */
  calcularRentalTotalCompleto = (rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) => {
    return this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
  };

  validateForm = () => {
    const { vehicleId, gpsDeviceId, r_gps, checkedF, value_to_charge, valueToChargeConfirmed, cancelInsuranceValue, isPendingTour, clientRewards, rewards } = this.state;
    
    const errors = [];
    
    // Validaciones básicas para ambos tipos de tour
    if (this.getModelName1() !== "Own Motorcycle" && vehicleId === 0) {
      errors.push("Please select a motorcycle");
    }
    
    // Validación de GPS: K1600GT no permite GPS
    if (this.getModelName1() === "K1600GT" && r_gps) {
      errors.push("GPS is not available for K1600GT model");
    }
    
    if (r_gps && this.getModelName1() !== "K1600GT" && gpsDeviceId === 0) {
      errors.push("Please select a GPS device");
    }
    
    // Validación de rewards mejorada
    if (this.rewardsNotOk()) {
      const { rewards, clientRewards, rental } = this.state;
      
      // Mensaje más específico según el caso
      if (rental && rental.booking && rental.booking.reward_used) {
        const tourRewards = parseInt(rental.booking.rewards, 0) || 0;
        const requestedRewards = parseInt(rewards, 0);
        
        if (requestedRewards > tourRewards) {
          errors.push(`Requested rewards (${requestedRewards}) exceed the rewards already assigned to this tour (${tourRewards})`);
        } else {
          errors.push("Requested rewards are not available");
        }
      } else {
        errors.push("Requested rewards are not available");
      }
    }
    
    // ✅ MODIFICACIÓN: Permitir value_to_charge = 0 para tours pendientes
    /* if (value_to_charge < cancelInsuranceValue && !(isPendingTour && value_to_charge === 0)) {
      errors.push("Invalid value to be charged");
    } */
    
    /* if (!checkedF) {
      errors.push("Please confirm the value to be charged");
    } */
    
    // ✅ MODIFICACIÓN: Permitir value_to_charge = 0 para tours pendientes
    if (isPendingTour) {
      if (value_to_charge < 0) {
        errors.push("Value to charge cannot be negative");
      }
      // Removido: if (value_to_charge <= 0) - ahora permite 0
    }
    
    // Validaciones específicas para tours ya procesados
    if (!isPendingTour) {
      // Validar que el valor a cargar sea razonable
      if (value_to_charge < 0) {
        errors.push("Value to charge cannot be negative");
      }
      
      // Validar comentarios si están vacíos (opcional)
      if (!this.state.imt_commentN && !this.state.extra_comments) {
        // Solo mostrar warning, no error
        console.warn("Consider adding comments for processed tours");
      }
    }
    
    return errors;
  };

  // Render methods
  renderOptionsSection() {
    const { r_gps, r_insurance, r_cancel_insurance, low_seat, r_single, r_double, r_insurance_disabled, r_gps_disabled, isPendingTour, partial, resend, sendFinalConfirmation, r_documentacion } = this.state;

    return (
      <FormSection>
        <SectionTitle variant="h6">Tour Options</SectionTitle>
        <OptionGrid container spacing={2}>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={r_gps}
                  onChange={(e) => this.handleCheckChange(e, 'r_gps')}
                  disabled={r_gps_disabled}
                  color="primary"
                />
              }
              label="GPS Device"
            />
          </Grid>
          <Grid item xs={6}>
            <InputLabel htmlFor="r_insurance_id">Insurance</InputLabel>
            <Select
              name="r_insurance_id"
              id="r_insurance_id"
              fullWidth
              value={this.state.r_insurance_id}
              disabled={r_insurance_disabled}
              onChange={e => {
                const id = normalizeInsuranceId(e.target.value);
                this.setState(
                  {
                    r_insurance_id: id,
                    r_insurance: isPaidInsurance(id),
                  },
                  () => this.recalcularValorTotalTour()
                );
              }}
            >
              {insuranceSelectChoices(
                this.calculateEffectiveDays(this.state.rental) || 0
              ).map(opt => (
                <MenuItem
                  key={opt.id}
                  value={opt.id}
                  disabled={!!opt.disabled}
                >
                  {opt.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          {/* Solo mostrar Cancel Insurance si el tour está pendiente (rental_status === 0) */}
          {isPendingTour && (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={r_cancel_insurance}
                    onChange={(e) => this.handleCheckChange(e, 'r_cancel_insurance')}
                    color="primary"
                  />
                }
                label="Cancel Insurance"
              />
            </Grid>
          )}
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={low_seat}
                  onChange={(e) => this.handleCheckChange(e, 'low_seat')}
                  color="primary"
                />
              }
              label="Low Seat"
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={r_single}
                  onChange={(e) => this.handleCheckChange(e, 'r_single')}
                  color="primary"
                />
              }
              label="Single Room"
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={r_double}
                  onChange={(e) => this.handleCheckChange(e, 'r_double')}
                  color="primary"
                />
              }
              label="Double Room"
            />
          </Grid>
          <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={r_documentacion  || false}
                      onChange={(e) => this.handleCheckChange(e, 'r_documentacion')}
                      color="primary"
                    />
                  }
                  label="Required Documentation"
                />
              </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => this.setState({ clientDocumentsModalOpen: true })}
              disabled={!(this.state.rental && this.state.rental.client_id)}
            >
              View / upload client documents
            </Button>
          </Grid>
          {/* Opciones adicionales para tours procesados */}
        {/*   {!isPendingTour && (
            <div style={{ marginTop: 16, marginBottom: 16, width: "100%" }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Partial Value to Pay (€)"
                  type="number"
                  value={partial}
                  onChange={(e) => this.handleChange(e, "partial")}
                  margin="normal"
                  inputProps={{
                    step: "0.01",
                    min: "0"
                  }}
                  helperText="Enter partial payment amount"
                />
              </Grid>
            </div>
          )} */}
        </OptionGrid>
      </FormSection>
    );
  }

  renderVehicleSection() {
    const { models, vehicles, gpsDevices, vehicle_model_1, vehicleId, gpsDeviceId, r_gps, r_gps_disabled, priceDate, date_1, date_2, rental } = this.state;
    const vehicleList = vehicles || [];
    const selectedFromRental = rental && rental.selected_vehicle_from_items;
    const listWithSelected = (() => {
      if (!vehicleId || vehicleId === 0 || !selectedFromRental || selectedFromRental.id !== vehicleId) return vehicleList;
      if (vehicleList.some((v) => Number(v.id) === Number(vehicleId))) return vehicleList;
      return [{ ...selectedFromRental, date_2: rental.date_2 || "" }, ...vehicleList];
    })();
    return (
      <FormSection>
        <SectionTitle variant="h6">Motorcycle Selection</SectionTitle>
        
        <TextField
          fullWidth
          label="Applicable Price Date"
          type="date"
          disabled={true}
          value={moment.utc(priceDate).format("YYYY-MM-DD")}
          onChange={(e) => this.handleChange(e, "priceDate")}
          InputLabelProps={{ shrink: true }}
          margin="normal"
        />

        <InputLabel>Model</InputLabel>
        {(() => {
        
          return null;
        })()}
        <StyledSelect
          value={vehicle_model_1 || ""}
          onChange={(e) => this.handleChange(e, "vehicle_model_1")}
        >
          {map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.model_name}
            </MenuItem>
          ), models)}
        </StyledSelect>
       
        <InputLabel>Motorcycle *</InputLabel>
        <StyledSelect
          key={`motorcycle-select-${listWithSelected.length}-${vehicleId}`}
          value={vehicleId == null || vehicleId === "" ? 0 : Number(vehicleId)}
          onChange={(e) => this.handleChange(e, "vehicleId")}
          displayEmpty
          renderValue={(v) => {
            if (!v || v === 0) return "";
            const sel = listWithSelected.find((item) => Number(item.id) === Number(v));
            if (!sel) return "";
            const color = sel.vehicle_color != null && sel.vehicle_color !== "" ? sel.vehicle_color : "-";
            const mileage = sel.vehicle_mileage != null && sel.vehicle_mileage !== "" ? sel.vehicle_mileage : "-";
            return `${sel.licence_plate || ""} ${sel.renting ? "®" : ""} (${color} / ${mileage} kms)`;
          }}
        >
          <MenuItem value={0}>Please select motorcycle</MenuItem>
          {map(item => {
            const itemDate = (item.date_2 || "").slice(0, 10);
           // console.log('item', item);
            if (itemDate === date_1 || this.checkOneDay(item)) {
              return (
                <MenuItem value={item.id} key={item.id}>
                  /!\** {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color != null ? item.vehicle_color : "-"} / {item.vehicle_mileage != null ? item.vehicle_mileage : "-"} kms) **/!\
                </MenuItem>
              );
            }
            return (
              <MenuItem value={item.id} key={item.id}>
                {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color != null ? item.vehicle_color : "-"} / {item.vehicle_mileage != null ? item.vehicle_mileage : "-"} kms)
              </MenuItem>
            );
          }, listWithSelected)}
        </StyledSelect>
        {vehicleId === 0 && this.getModelName1() !== "Own Motorcycle" && (
          <ErrorText>* Please select Motorcycle</ErrorText>
        )}

        {!r_gps_disabled && r_gps && (
          <React.Fragment>
            <InputLabel>GPS Device *</InputLabel>
            <StyledSelect
              value={gpsDeviceId}
              onChange={(e) => this.handleChange(e, "gpsDeviceId")}
            >
              <MenuItem value={0}>Please select GPS device</MenuItem>
              {map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.model}
                </MenuItem>
              ), gpsDevices)}
            </StyledSelect>
            {gpsDeviceId === 0 && r_gps && (
              <ErrorText>* Please select GPS device</ErrorText>
            )}
          </React.Fragment>
        )}
      </FormSection>
    );
  }

  renderPricingSection() {
    const { value_to_charge, rewards, discount, clientRewards, checkedF,  reward_used,cancelInsuranceValue, isPendingTour, pricingValidation, motorcycleValidation,  chargeSuplement, customValueEnabled, customValueToCharge, customValueToChargeString, initialDisplayValueToCharge, confirmedValueToCharge, isValueConfirmed, valueToChargeConfirmed } = this.state;
    const { rental } = this.state;

    if (!rental) return null;

    const rentalAheadSixtyDays = moment(rental.effective_start_date).diff(Date.now(), "days") >= 60;

    //this.recalcularValorTotalTour();

    // ✅ CORRECCIÓN: Usar valor local calculado cuando hay cambios locales
    // Si valueToChargeCalculatedByUpdatePricing es true, usar value_to_charge del estado
    // Si no, usar calculated_due del API solo si no hay cambios locales
    const hasLocalChanges = this.state.valueToChargeCalculatedByUpdatePricing && 
                            this.state.pricingBreakdown && 
                            this.state.pricingBreakdown.final_total !== undefined;
    

   // console.log('valueToChargeConfirmed', valueToChargeConfirmed);
   // console.log('this.state.value_to_charge', this.state.value_to_charge);
   // console.log('rental.calculated_due', rental.calculated_due);
   // console.log('isPendingTour', isPendingTour);

    const displayValueToCharge = hasLocalChanges
      ? (this.state.value_to_charge || '0.00')
      : (rental.calculated_due !== undefined && rental.calculated_due !== null && !isPendingTour
          ? rental.calculated_due.toFixed(2)
          : (valueToChargeConfirmed || this.state.value_to_charge || '0.00'));

        //  console.log('displayValueToCharge', displayValueToCharge);
    // ✅ CORRECCIÓN: Usar el valor inicial guardado para el título si está disponible
    // Esto asegura que el título siempre muestre el valor original, no el que se está editando
    const titleDisplayValue = initialDisplayValueToCharge > 0 
      ? initialDisplayValueToCharge.toFixed(2) 
      : displayValueToCharge;
   // console.log('titleDisplayValue', titleDisplayValue);

    return (
      <FormSection>
        <SectionTitle variant="h6">Discount & Rewards</SectionTitle>
    
        {/* Información de Rewards - Ocultar si el tour es p4m o global tours (tour_category_id === 3) */}
        {!(rental.booking && rental.booking.tour && rental.booking.tour.tour_category_id === 3) && (
          <div>
            <div style={{ marginBottom: 16, padding: 12, backgroundColor: '#f5f5f5', borderRadius: 8 }}>
              <Typography variant="subtitle1" gutterBottom>
                <b>Rewards Information</b>
              </Typography>
              
              <Typography variant="body2" style={{ marginBottom: 8 }}>
                <b>Available Rewards:</b> €{clientRewards}
              </Typography>
              
              {/* Mostrar rewards ya asignados al tour si es un tour procesado */}
             {/*  {!isPendingTour && rental && rental.booking && rental.booking.reward_used && (
                <Typography variant="body2" style={{ marginBottom: 8, color: '#1976d2' }}>
                  <b>Rewards already assigned to this tour:</b> €{rental.booking.rewards || 0}
                </Typography>
              )} */}
              
              {/* Mostrar información adicional para tours procesados */}
             {/*  {!isPendingTour && rental && rental.booking && rental.booking.reward_used && (
                <Typography variant="body2" style={{ fontSize: '0.875rem', color: '#666', fontStyle: 'italic' }}>
                  Note: You can use up to the amount already assigned to this tour (€{rental.booking.rewards || 0})
                </Typography>
              )} */}
            </div>
            
            <TextField
              fullWidth
              label="Rewards requested to use"
              type="number"
              value={rewards}
              onChange={(e) => this.handleChange(e, "rewards")}
              margin="normal"
              helperText={!isPendingTour && rental && rental.booking && rental.booking.reward_used 
                ? `Maximum allowed: €${rental.booking.rewards || 0} (already assigned to this tour)`
                : `Maximum available: €${clientRewards}`
              }
            />
          </div>
        )}
        
        {this.rewardsNotOk() && (
          <ErrorText>
            {!isPendingTour && rental && rental.booking && rental.booking.reward_used 
              ? `Requested rewards exceed the amount already assigned to this tour (€${rental.booking.rewards || 0})`
              : "Requested rewards are not available!"
            }
          </ErrorText>
        )}

        <TextField
          fullWidth
          label="Discount"
          type="number"
          value={discount}
          onChange={(e) => this.handleChange(e, "discount")}
          margin="normal"
        />
        
        {/* Campos adicionales para tours ya procesados */}
        {/* {this.renderAdditionalFields()} */}
         {/* Add Supplement functionality for processed tours */}
         {!isPendingTour && (
          <div style={{ marginTop: 16, padding: 16, backgroundColor: '#fff3e0', borderRadius: 8, border: '1px solid #ff9800' }}>
            <Typography variant="h6" style={{ color: '#f57c00', marginBottom: 12 }}>
              Additional Charges
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
              Add supplementary charges for additional services or modifications.
            </Typography>
            {chargeSuplement > 0 && (
                <Grid item xs={12}>
                  <CustomAlert className="warning">
                    <Typography variant="subtitle2">
                      Pending supplementary charges: €{chargeSuplement.toFixed(2)}
                    </Typography>
                  </CustomAlert>
                </Grid>
              )}
            <AddSuplementCharge rental={rental} extraCharge={true} />
          </div>
        )}

        <br />
        <SectionTitle variant="h6">Pricing & Payment</SectionTitle>
    
        <PriceDisplay>
                    <Typography variant="h6" gutterBottom>
                        Value to be charged: €{titleDisplayValue}
                      </Typography>

                      <FormControlLabel
            control={
              <Checkbox
                checked={checkedF}
                onChange={(e) => this.handleCheckChange(e, "checkedF", displayValueToCharge)}
                color="primary"
              />
            }
            label="Confirm value to be charged!"
          />
          
          {/* Custom amount input field when checkbox is checked */}
          {customValueEnabled && parseFloat(displayValueToCharge) >= 0 && (
            <div style={{ marginTop: 16, marginBottom: 16 }}>
              <TextField
                label="Custom amount (€)"
                type="text"
                value={customValueToChargeString !== undefined && customValueToChargeString !== "" ? customValueToChargeString : (customValueToCharge > 0 ? customValueToCharge.toFixed(2) : "")}
                onChange={(e) => this.handleCustomValueChange(e, titleDisplayValue)}
                //onBlur={(e) => this.handleCustomValueBlur(e, titleDisplayValue)}
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{
                  step: "0.01",
                  min: "0"
                }}
                helperText={`Enter the amount you want to charge (max: €${titleDisplayValue})`}
              />
            </div>
          )}
          
          {/* ✅ MOSTRAR MENSAJE CUANDO NO HAY NADA QUE COBRAR */}
          {customValueEnabled && parseFloat(titleDisplayValue) === 0 && (
            <div style={{ marginTop: 16, marginBottom: 16, padding: 12, backgroundColor: '#e8f5e8', borderRadius: 8, border: '1px solid rgb(224, 224, 224)' }}>
              <Typography variant="body2" style={{ color: '#2e7d32', fontStyle: 'italic' }}>
                ✅ Custom amount field available - you can set the charge to €0.00 (no charge will be created)
              </Typography>
            </div>
          )}
          
        {/*   {value_to_charge < cancelInsuranceValue && !(isPendingTour && value_to_charge === 0) && (
            <ErrorText>* Invalid Value to be charged</ErrorText>
          )} */}
        </PriceDisplay>

        {/* Mostrar validaciones de precios */}
        {pricingValidation && (
          <div style={{ marginTop: 16 }}>
            {pricingValidation.errors.length > 0 && (
              <div style={{ color: 'red', marginBottom: 8 }}>
                <Typography variant="subtitle2" color="error">
                  Pricing calculation errors:
                </Typography>
                {pricingValidation.errors.map((error, index) => (
                  <Typography key={index} variant="body2" color="error">
                    • {error}
                  </Typography>
                ))}
              </div>
            )}
            
            {pricingValidation.warnings.length > 0 && (
              <div style={{ color: 'orange', marginBottom: 8 }}>
                <Typography variant="subtitle2" style={{ color: 'orange' }}>
                  Pricing calculation warnings:
                </Typography>
                {pricingValidation.warnings.map((warning, index) => (
                  <Typography key={index} variant="body2" style={{ color: 'orange' }}>
                    • {warning}
                  </Typography>
                ))}
              </div>
            )}
          </div>
        )}

        
      </FormSection>
    );
  }

  renderAdditionalFields() {
    const { isPendingTour, imt_commentN, extra_comments, r_documentacion, chargeSuplement, invoice_comments, comments } = this.state;
    
    return (
      <FormSection>
        <SectionTitle variant="h6">Additional Information</SectionTitle>
        <Grid container spacing={2}>
          {/* Mostrar comentarios previos de IMT solo para tours procesados */}
          {!isPendingTour && comments && (
            <Grid item xs={12}>
              <div style={{ backgroundColor: 'yellow', padding: '8px', borderRadius: '4px', marginBottom: '16px' }}>
                <Typography variant="subtitle2" style={{ color: '#ff6f00' }}>
                  IMT previous comments: {comments}
                </Typography>
              </div>
            </Grid>
          )}
          
          {/* Campo IMT Comments para todos los tours (pendientes y procesados) */}
          <Grid item xs={12}>
            <TextField
              label="IMT Comments"
              value={imt_commentN || ""}
              onChange={(e) => this.handleAdditionalFieldChange(e, 'imt_commentN')}
              fullWidth
              multiline
              rows={3}
              variant="outlined"
            />
          </Grid>
          
          {/* Campos adicionales solo para tours procesados */}
          {!isPendingTour && (
            <React.Fragment>
              <Grid item xs={12}>
                <TextField
                  label="Invoice Comments"
                  value={invoice_comments || ""}
                  onChange={(e) => this.handleAdditionalFieldChange(e, 'invoice_comments')}
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  label="Comments to agent"
                  value={extra_comments || ""}
                  onChange={(e) => this.handleAdditionalFieldChange(e, 'extra_comments')}
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                />
              </Grid>

            </React.Fragment>
          )}
        </Grid>
      </FormSection>
    );
  }

  renderSummarySection() {
    const { 
      rental, 
      r_gps, 
      r_insurance, 
      r_cancel_insurance, 
      r_single,
      low_seat,
      isPendingTour, 
      chargeSuplement, 
      partial, 
      resend, 
      sendFinalConfirmation,
      // ✅ USAR ÚNICAMENTE LOS VALORES CALCULADOS POR updatePricingBreakdown
      effectiveDays,
      pricingBreakdown,
      value_to_charge,
      clientRewards,
      insurancePrices
    } = this.state;
    
    if (!rental) {
      return null;
    }

    if (!rental.booking) {
      return null;
    }

    // ✅ NUEVO: Usar calculated_price_dynamic del API si está disponible
    const apiBreakdown = rental.calculated_price_dynamic && rental.calculated_price_dynamic.breakdown;
    
    // ✅ CORRECCIÓN: NO usar datos del API si se han hecho cambios locales
    // Si pricingBreakdown existe y tiene valores calculados recientemente, usar esos en lugar del API
    // Esto asegura que los cambios del usuario (toggles GPS, VIP, etc.) se reflejen inmediatamente
    const hasLocalCalculations = pricingBreakdown && (
      pricingBreakdown.gps_total !== undefined || 
      pricingBreakdown.vip_insurance !== undefined ||
      pricingBreakdown.single_room !== undefined ||
      pricingBreakdown.final_total !== undefined
    );
    
    // ✅ DETECTAR SI HAY CAMBIOS LOCALES ACTIVOS
    // Si hay toggles activados (r_gps, r_insurance, r_single) Y hay valores calculados localmente,
    // entonces debemos usar pricingBreakdown en lugar de apiBreakdown para reflejar los cambios del usuario
    const hasActiveToggles = r_gps || r_insurance || r_single || r_cancel_insurance || low_seat;
    const hasLocalValues = pricingBreakdown && (
      pricingBreakdown.gps_total !== undefined || 
      pricingBreakdown.vip_insurance !== undefined ||
      pricingBreakdown.single_room !== undefined ||
      pricingBreakdown.final_total !== undefined
    );
    
    // ✅ Si hay toggles activados Y valores locales, forzar el uso de pricingBreakdown
    // Esto asegura que los cambios del usuario se reflejen inmediatamente en el UI
    const shouldUseLocalData = hasActiveToggles && hasLocalValues;
    
    // ✅ También verificar si valueToChargeCalculatedByUpdatePricing es true (cálculo reciente)
    const hasRecentCalculation = this.state.valueToChargeCalculatedByUpdatePricing;
    
    // ✅ Determinar qué fuente de datos usar
    // PRIORIDAD 1: Si hay toggles activados Y valores locales, usar pricingBreakdown (cambios del usuario)
    // PRIORIDAD 2: Si hay cálculo reciente Y valores locales, usar pricingBreakdown
    // PRIORIDAD 3: Si es un tour procesado y hay datos del API pero NO hay cambios locales, usar API
    // PRIORIDAD 4: Si es un tour pendiente o no hay datos del API, usar pricingBreakdown
    const useApiData = apiBreakdown && !isPendingTour && !shouldUseLocalData && !hasRecentCalculation;
    
    // Debug: Log para verificar qué fuente de datos se está usando
    if (hasActiveToggles) {
     /* console.log('📊 renderSummarySection - Data Source Decision:', {
        useApiData,
        shouldUseLocalData,
        hasRecentCalculation,
        hasActiveToggles,
        hasLocalValues,
        r_gps,
        r_insurance,
        r_single,
        pricingBreakdown_gps_total: pricingBreakdown && pricingBreakdown.gps_total,
        apiBreakdown_gps: apiBreakdown && apiBreakdown.gps,
        valueToChargeCalculatedByUpdatePricing: this.state.valueToChargeCalculatedByUpdatePricing
      });*/
    }
    
    // ✅ Usar tourDuration del API si está disponible
    const effectiveDaysFromApi = rental.calculated_price_dynamic && rental.calculated_price_dynamic.tourDuration;
    const displayEffectiveDays = useApiData && effectiveDaysFromApi ? effectiveDaysFromApi : (effectiveDays || 0);
    
    // ✅ CORRECCIÓN: Usar valor local calculado cuando hay cambios locales
    // Si hay cambios locales activos (toggles + cálculos), usar value_to_charge del estado
    // Si no hay cambios locales pero hay datos del API, usar API
    // Si no hay nada, usar value_to_charge del estado
    const apiCalculatedDue = rental.calculated_due;
  //  console.log('apiCalculatedDue', apiCalculatedDue);
  //  console.log('value_to_charge', value_to_charge);
  //  console.log('shouldUseLocalData', shouldUseLocalData);
  //  console.log('hasRecentCalculation', hasRecentCalculation);
  //  console.log('useApiData', useApiData); 
  //  console.log('displayValueToCharge', displayValueToCharge);

    // ✅ PRIORIDAD: Si hay cambios locales, SIEMPRE usar el valor calculado localmente
    const displayValueToCharge = (shouldUseLocalData || hasRecentCalculation)
      ? (value_to_charge || '0.00')
      : (useApiData && apiCalculatedDue !== undefined && apiCalculatedDue !== null 
          ? apiCalculatedDue.toFixed(2)
          : (value_to_charge || '0.00'));
    
    // Debug: Log para verificar qué valor se está usando
    if (hasActiveToggles) {
     /* console.log('💰 displayValueToCharge Decision:', {
        shouldUseLocalData,
        hasRecentCalculation,
        useApiData,
        value_to_charge,
        apiCalculatedDue,
        displayValueToCharge,
        final_total: pricingBreakdown && pricingBreakdown.final_total,
        totalPaid: this.calculateTotalPaid(rental).totalPaid
      });*/
    }
    
    // ✅ CALCULAR LOS TOTALES BASADOS EN pricingBreakdown o API breakdown
    const firstChoiceTotal = useApiData 
      ? (apiBreakdown.total || 0)
      : (pricingBreakdown && pricingBreakdown.final_total ? pricingBreakdown.final_total : 0);
    
    // ✅ Calcular secondChoiceTotal: recalcular todo con el modelo 2
    let secondChoiceTotal = 0;
    if (useApiData && apiBreakdown && pricingBreakdown && pricingBreakdown.vehicle_model_2 !== undefined) {
      const vehicleModel2Price = pricingBreakdown.vehicle_model_2 || 0;
      
      // ✅ NUEVO: Recalcular seguro de cancelación para el modelo 2
      let cancelInsuranceModel2 = 0;
      
      if (r_cancel_insurance && insurancePrices && insurancePrices.length > 0) {
        const cancelInsurance = insurancePrices.find(p => p.price_item_type === "insurance" && p.price_item_id === 3);
        if (cancelInsurance) {
          const percentage = cancelInsurance.percentage || 7.5;
          // Base para cálculo modelo 2: tour + passenger + vehicle_model_2 (no vehicle_model_1) + GPS + single
          const baseForCancelInsuranceModel2 = apiBreakdown.tour + apiBreakdown.passenger + vehicleModel2Price + apiBreakdown.gps + apiBreakdown.single;
          cancelInsuranceModel2 = (baseForCancelInsuranceModel2 * percentage) / 100;
        }
      }
      
      // ✅ Recalcular subtotal con modelo 2: tours + passenger + vehicle_model_2 + GPS + single + supplements
      const subtotalModel2 = apiBreakdown.tour + apiBreakdown.passenger + vehicleModel2Price + apiBreakdown.gps + apiBreakdown.single + apiBreakdown.supplements;
      
      // Total = subtotal modelo 2 + seguros modelo 2 + VIP - descuentos - rewards
      const apiVipInsurance = apiBreakdown.vipInsurance || 0;
      const apiDiscount = apiBreakdown.discount || 0;
      const apiRewards = apiBreakdown.rewards || 0;
      
      secondChoiceTotal = subtotalModel2 + cancelInsuranceModel2 + apiVipInsurance - apiDiscount - apiRewards;
    } else {
      // Si no usamos API data, usar pricingBreakdown normal
      secondChoiceTotal = pricingBreakdown && pricingBreakdown.final_total2 ? pricingBreakdown.final_total2 : 0;
    }
    
   /*  console.log('🎨 Render Summary Section:', {
      firstChoiceTotal: firstChoiceTotal,
      secondChoiceTotal: secondChoiceTotal,
      pricingBreakdown: pricingBreakdown,
      discount: this.state.discount,
      rewards: this.state.rewards,
      clientRewards: this.state.clientRewards,
      originalClientRewards: this.state.originalClientRewards,
      valueToChargeConfirmed: this.state.valueToChargeConfirmed,
      isProcessedTour: this.state.rental && this.state.rental.booking && this.state.rental.booking.reward_used,
      tourRewards: this.state.rental && this.state.rental.booking ? this.state.rental.booking.rewards : 0
    }); */

    let dayActual = moment(Date.now()).format("YYYY-MM-DD")

    // Si booking está vacío/nulo, usar datos actualizados del cliente (driver)
    const pickFilled = (...vals) => {
      const found = vals.find((v) => !isNil(v) && !isEmpty(String(v).trim()));
      return found != null ? String(found).trim() : null;
    };
    const driver = rental.driver || {};
    const booking = rental.booking || {};
    const bookingClient = booking.client || {};
    const anotherPerson = Number(booking.is_for) === 2;
    const displayPassport = anotherPerson
      ? (pickFilled(booking.r_passport) || "N/A")
      : (pickFilled(booking.r_passport, driver.passport, bookingClient.passport) || "N/A");
    const displayLicense = anotherPerson
      ? (pickFilled(booking.r_license) || "N/A")
      : (pickFilled(
        booking.r_license,
        driver.driving_licence,
        bookingClient.driving_licence
      ) || "N/A");
    const displayAddressParts = (anotherPerson
      ? [
        pickFilled(booking.r_address),
        pickFilled(booking.r_zip),
        pickFilled(booking.r_city),
      ]
      : [
        pickFilled(booking.r_address, driver.client_address, bookingClient.client_address),
        pickFilled(booking.r_zip, driver.client_zip, bookingClient.client_zip),
        pickFilled(booking.r_city, driver.client_city, bookingClient.client_city),
      ]).filter(Boolean);
    const displayAddress =
      displayAddressParts.length > 0 ? displayAddressParts.join(", ") : "N/A";

    return (
      <div>

        <SectionTitle variant="h6">Tour Summary</SectionTitle>
        {rental.booking.tour && (
          <SummaryItem>
            <SummaryLabel>Tour:</SummaryLabel>
            <SummaryValue>{rental.booking.tour.tour_name.tour_name_en}</SummaryValue>
          </SummaryItem>
        )}

        <SummaryItem>
          <SummaryLabel>Booking Date:</SummaryLabel>
          <SummaryValue>
            {moment.utc(rental.booking.r_timestamp).format("DD/MM/YYYY HH:mm:ss")}
          </SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Days Left:</SummaryLabel>
          <SummaryValue>
          {moment.utc(rental.date_1).diff(dayActual, "days")}
          </SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>P4M:</SummaryLabel>
          <SummaryValue>{rental.booking.p4m ? "Yes" : "No"}</SummaryValue>
        </SummaryItem>
        
        {rental.booking.tour && (
          <React.Fragment>
            <SummaryItem>
              <SummaryLabel>Tour Start Date:</SummaryLabel>
              <SummaryValue>
                {moment.utc(rental.booking.tour.effective_start_date).format("DD, dddd, MMM YYYY")}
              </SummaryValue>
            </SummaryItem>
            
            <SummaryItem>
              <SummaryLabel>Tour End Date:</SummaryLabel>
              <SummaryValue>
                {moment.utc(rental.booking.tour.effective_end_date).format("DD, dddd, MMM YYYY")}
              </SummaryValue>
            </SummaryItem>
          </React.Fragment>
        )}
        
        <SummaryItem>
          <SummaryLabel>Rider days:</SummaryLabel>
          <SummaryValue>{displayEffectiveDays || 0} days</SummaryValue>
        </SummaryItem>
        
        {/* ✅ MOSTRAR DESGLOSE DETALLADO DE PRECIOS */}
        {useApiData && apiBreakdown ? (
          <React.Fragment>
            <SummaryItem>
              <SummaryLabel>Tour Base Price:</SummaryLabel>
              <SummaryValue>€{(apiBreakdown.tour || 0).toFixed(2)}</SummaryValue>
            </SummaryItem>
            
            {apiBreakdown.vehicle > 0 && (
              <SummaryItem>
                <SummaryLabel>Vehicle Model Price:</SummaryLabel>
                <SummaryValue>€{(apiBreakdown.vehicle || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.passenger > 0 && (
              <SummaryItem>
                <SummaryLabel>Passenger Price:</SummaryLabel>
                <SummaryValue>€{(apiBreakdown.passenger || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.single > 0 && (
              <SummaryItem>
                <SummaryLabel>Single Room:</SummaryLabel>
                <SummaryValue>€{(apiBreakdown.single || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.gps > 0 && (
              <SummaryItem>
                <SummaryLabel>GPS:</SummaryLabel>
                <SummaryValue>€{(apiBreakdown.gps || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.vipInsurance > 0 && (
              <SummaryItem>
                <SummaryLabel>VIP Insurance:</SummaryLabel>
                <SummaryValue>€{(apiBreakdown.vipInsurance || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.cancellationInsurance > 0 && (
              <SummaryItem>
                <SummaryLabel>Cancel Insurance:</SummaryLabel>
                <SummaryValue>€{(apiBreakdown.cancellationInsurance || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.supplements > 0 && (
              <SummaryItem>
                <SummaryLabel>Pending Supplements:</SummaryLabel>
                <SummaryValue style={{ color: "#f44336" }}>€{(apiBreakdown.supplements || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.discount > 0 && (
              <SummaryItem>
                <SummaryLabel>Discount:</SummaryLabel>
                <SummaryValue style={{ color: "#4caf50" }}>€{(apiBreakdown.discount || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {apiBreakdown.rewards > 0 && (
              <SummaryItem>
                <SummaryLabel>Rewards Used:</SummaryLabel>
                <SummaryValue style={{ color: "#000000" }}>€{(apiBreakdown.rewards || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            <Divider style={{ margin: "16px 0" }} />

          </React.Fragment>
        ) : pricingBreakdown ? (
          <React.Fragment>
            <SummaryItem>
              <SummaryLabel>Tour Base Price:</SummaryLabel>
              <SummaryValue>€{(pricingBreakdown.tour_total || 0).toFixed(2)}</SummaryValue>
            </SummaryItem>
            
            {pricingBreakdown.vehicle_model > 0 && (
              <SummaryItem>
                <SummaryLabel>Vehicle Model Price:</SummaryLabel>
                <SummaryValue>€{(pricingBreakdown.vehicle_model || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {pricingBreakdown.passenger_price > 0 && (
              <SummaryItem>
                <SummaryLabel>Passenger Price:</SummaryLabel>
                <SummaryValue>€{(pricingBreakdown.passenger_price || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {r_single && pricingBreakdown.single_room > 0 && (
              <SummaryItem>
                <SummaryLabel>Single Room:</SummaryLabel>
                <SummaryValue>€{(pricingBreakdown.single_room || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {r_gps && (
              <SummaryItem>
                <SummaryLabel>GPS:</SummaryLabel>
                <SummaryValue>
                  €{(pricingBreakdown.gps_total || 0).toFixed(2)}
                  {effectiveDays > 0 && pricingBreakdown.gps_total > 0 && (
                    <span> (€{(pricingBreakdown.gps_total / effectiveDays).toFixed(2)}/day)</span>
                  )}
                </SummaryValue>
              </SummaryItem>
            )}
            
            {r_insurance && pricingBreakdown.vip_insurance > 0 && (
              <SummaryItem>
                <SummaryLabel>VIP Insurance:</SummaryLabel>
                <SummaryValue>€{(pricingBreakdown.vip_insurance || 0).toFixed(2)} (€{(pricingBreakdown.vip_insurance / effectiveDays || 0).toFixed(2)}/day)</SummaryValue>
              </SummaryItem>
            )}
            
            {r_cancel_insurance && pricingBreakdown.cancel_insurance > 0 && (
              <SummaryItem>
                <SummaryLabel>Cancel Insurance:</SummaryLabel>
                <SummaryValue>€{(pricingBreakdown.cancel_insurance || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {low_seat && pricingBreakdown.low_seat > 0 && (
              <SummaryItem>
                <SummaryLabel>Low Seat:</SummaryLabel>
                <SummaryValue>€{(pricingBreakdown.low_seat || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {pricingBreakdown.pending_supplements > 0 && (
              <SummaryItem>
                <SummaryLabel>Pending Supplements:</SummaryLabel>
                <SummaryValue style={{ color: "#f44336" }}>€{(pricingBreakdown.pending_supplements || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {pricingBreakdown.discount > 0 && (
              <SummaryItem>
                <SummaryLabel>Discount:</SummaryLabel>
                <SummaryValue style={{ color: "#4caf50" }}>€{(pricingBreakdown.discount || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {pricingBreakdown.rewards > 0 && (
              <SummaryItem>
                <SummaryLabel>Rewards Used:</SummaryLabel>
                <SummaryValue style={{ color: "#000000" }}>€{(pricingBreakdown.rewards || 0).toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            <Divider style={{ margin: "16px 0" }} />

          </React.Fragment>
        ) : null}
        
        <SummaryItem>
          <SummaryLabel>First Choice Motorcycle:</SummaryLabel>
          <SummaryValue>{this.getModelName(rental.booking.vehicle_model_1)}</SummaryValue>
        </SummaryItem>
        
        <SummaryItem>
          <SummaryLabel>Second Choice Motorcycle:</SummaryLabel>
          <SummaryValue>{this.getModelName(rental.booking.vehicle_model_2)}</SummaryValue>
        </SummaryItem>
        
        {!isNil(rental.booking.p_first_name) && (
          <SummaryItem>
            <SummaryLabel>Passenger:</SummaryLabel>
            <SummaryValue>{rental.booking.p_first_name} {rental.booking.p_last_name}</SummaryValue>
          </SummaryItem>
        )}
        
        {rental.booking.roommate && (
         <SummaryItem>
          <SummaryLabel>Roommate name:</SummaryLabel>
          <SummaryValue>{rental.booking.roommate}</SummaryValue>
        </SummaryItem>
        )}
        
        {/* ✅ MOSTRAR TOTALES CALCULADOS POR updatePricingBreakdown */}
        <SummaryItem>
          <SummaryLabel>First choice of motorcycle:</SummaryLabel>
          <SummaryValue style={{ fontWeight: 'bold', color: '#000000' }}>€{(firstChoiceTotal || 0).toFixed(2)}</SummaryValue>
        </SummaryItem>
        
        <SummaryItem>
          <SummaryLabel>Second choice of motorcycle:</SummaryLabel>
          <SummaryValue style={{ fontWeight: 'bold', color: '#000000' }}>€{(secondChoiceTotal || 0).toFixed(2)}</SummaryValue>
        </SummaryItem>
        
        {/* ✅ MOSTRAR VALUE TO CHARGE CALCULADO CENTRALIZADAMENTE */}
        <SummaryItem>
          <SummaryLabel>Value to Charge:</SummaryLabel>
          <SummaryValue style={{ fontWeight: 'bold', color: '#000000', fontSize: '1.1em' }}>€{displayValueToCharge}</SummaryValue>
        </SummaryItem>
        
        <SummaryItem>
          <SummaryLabel>Comments:</SummaryLabel>
          <SummaryValue>{isNil(rental.booking.r_comments) ? "" : rental.booking.r_comments}</SummaryValue>
        </SummaryItem>
        
        {/* Información adicional sobre rewards */}
      {/*   {rental.booking.reward_used && (
          <SummaryItem>
            <SummaryLabel>Rewards Status:</SummaryLabel>
            <SummaryValue style={{ color: "#4caf50" }}>
              ✓ Rewards used: €{rental.booking.rewards || 0}
            </SummaryValue>
          </SummaryItem>
        )}
         */}
        {!rental.booking.reward_used && clientRewards > 0 && (
          <SummaryItem>
            <SummaryLabel>Rewards Status:</SummaryLabel>
            <SummaryValue style={{ color: "#ff9800" }}>
              ⚠ Available rewards: €{clientRewards} (not used)
            </SummaryValue>
          </SummaryItem>
        )}
        
        {/* Mostrar información adicional para tours procesados */}
        {!isPendingTour && (
          <div>
            <Divider style={{ margin: "16px 0" }} />
            <Typography variant="subtitle2" style={{ color: "#1976d2", marginBottom: 8 }}>
              Additional Information (Processed Tour)
            </Typography>
            
            {chargeSuplement > 0 && (
              <SummaryItem>
                <SummaryLabel>Pending Supplementary Charges:</SummaryLabel>
                <SummaryValue style={{ color: "#f44336" }}>€{chargeSuplement.toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            
            {partial > 0 && (
              <SummaryItem>
                <SummaryLabel>Partial Payment:</SummaryLabel>
                <SummaryValue style={{ color: "#ff9800" }}>€{partial.toFixed(2)}</SummaryValue>
              </SummaryItem>
            )}
            <br />
            <Typography variant="subtitle2" style={{ color: "#1976d2", marginBottom: 8 }}>
              IMT Comments:
            </Typography>
            <SummaryItem>
                <span>{this.state.comments || "N/A"}</span>
            </SummaryItem>
          </div>
        )}
        
        <Divider style={{ margin: "16px 0" }} />
        
        <SummaryItem>
          <SummaryLabel>Client Passport:</SummaryLabel>
          <SummaryValue>{displayPassport}</SummaryValue>
        </SummaryItem>
        
        <SummaryItem>
          <SummaryLabel>Driving Licence:</SummaryLabel>
          <SummaryValue>{displayLicense}</SummaryValue>
        </SummaryItem>
        
        <SummaryItem>
          <SummaryLabel>Client Address:</SummaryLabel>
          <SummaryValue>{displayAddress}</SummaryValue>
        </SummaryItem>

        <SummaryItem>
          <SummaryLabel>Card Data:</SummaryLabel>
          <SummaryValue>{isNil(rental.clientData) ? "N/A" : rental.clientData}</SummaryValue>
        </SummaryItem>

        {/* Mostrar valor a cargar */}
        <div hidden={true} style={{ marginTop: 16, padding: 16, backgroundColor: '#f5f5f5', borderRadius: 8 }}>
          {/* Mostrar información adicional para tours procesados */}
          {!isPendingTour && partial > 0 && (
            <Typography variant="body2" style={{ color: '#ff9800', marginTop: 8 }}>
              Partial payment: €{Number(partial).toFixed(2)}
            </Typography>
          )}
          
          {!isPendingTour && resend && (
            <Typography variant="body2" style={{ color: '#2196f3', marginTop: 4 }}>
              ✓ Confirmation email will be resent
            </Typography>
          )}
          
          {!isPendingTour && sendFinalConfirmation && (
            <Typography variant="body2" style={{ color: '#4caf50', marginTop: 4 }}>
              ✓ Final confirmation will be sent
            </Typography>
          )}
        </div>
      </div>
    );
  }

  renderActions() {
    const { isOnSubmit, noConfirmationEmail, isPendingTour, value_to_charge, partial, resend, sendFinalConfirmation, rental } = this.state;
    const errors = this.validateForm();

    return (
      <FormSection>
      {/*   <SectionTitle variant="h6">
          {isPendingTour ? "Process Tour" : "Edit Tour"}
        </SectionTitle> */}
       {/*  <hr /> */}
        
        {/* Mostrar información específica según el tipo de tour */}
       {/*  {!isPendingTour && (
          <CustomAlert className="info" style={{ marginBottom: 16 }}>
            <Typography variant="subtitle2">
              <InfoIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
              This tour has already been processed. You can modify settings and add supplementary charges.
            </Typography>
          </CustomAlert>
        )} */}
        
        {/* Mostrar información específica sobre rewards para tours procesados */}
        {/* {!isPendingTour && rental && rental.booking && rental.booking.reward_used && (
          <CustomAlert className="success" style={{ marginBottom: 16 }}>
            <Typography variant="subtitle2">
              <CheckCircleIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
              This tour has rewards already assigned (€{rental.booking.rewards || 0}). You can use up to this amount.
            </Typography>
          </CustomAlert>
        )} */}
        
        {/* {isPendingTour && (
          <CustomAlert className="warning" style={{ marginBottom: 16 }}>
            <Typography variant="subtitle2">
              <WarningIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
              This is a pending tour. Please review all settings before processing. You can set the charge to €0.00 if no payment is required.
            </Typography>
          </CustomAlert>
        )} */}
        
       {/*  {errors.length > 0 && (
          <CustomAlert className="error" style={{ marginBottom: 16 }}>
            <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
              <ErrorIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
              Please fix the following errors:
            </Typography>
            {errors.map((error, index) => (
              <Typography key={index} variant="body2" style={{ marginLeft: 24 }}>
                • {error}
              </Typography>
            ))}
          </CustomAlert>
        )} */}
        <Grid item xs={12}> 
        <Grid item xs={12}> 
          <FormControlLabel
              control={
                <Checkbox
                  checked={noConfirmationEmail}
                  onChange={(e) => this.handleCheckChange(e, "noConfirmationEmail")}
                  color="primary"
                />
              }
              label="Don't send confirmation e-mail"
            />
            </Grid>
                {!isPendingTour && (  
                  <div>
                     <Grid item xs={12}> 
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={resend}
                      onChange={(e) => this.handleCheckChange(e, 'resend')}
                      color="primary"
                    />
                  }
                  label="Resend confirmation email"
                />
                </Grid>
                <Grid item xs={12}> 
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendFinalConfirmation}
                      onChange={(e) => this.handleCheckChange(e, 'sendFinalConfirmation')}
                      color="primary"
                    />
                  }
                  label="Send final confirmation"
                />
                </Grid>

                </div>
              )}
        </Grid>
        <Grid item xs={12}> 
          <br />
        </Grid>
        <Grid item xs={12}> 
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
          <div style={{ display: "flex", gap: "12px" }}>
            <ActionButton
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={this.handleSubmit}
              disabled={isOnSubmit}
            >
              {isOnSubmit ? "Processing..." : (isPendingTour ? "Save" : "Save")}
            </ActionButton>
            
        {/*     <ActionButton
              variant="outlined"
              color="secondary"
              onClick={this.testPricingData}
              disabled={isOnSubmit}
            >
              Test Data
            </ActionButton> */}
          </div>
        </div>
        </Grid>
      </FormSection>
    );
  }

  componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    this.fetchData();
  }

  async componentDidUpdate(prevProps, prevState) {
    
    // Detectar cambios en r_single y recalcular precios
    if (prevState.r_single !== this.state.r_single) {
      await this.getValueTobeChargeSingle();
      await this.recalcularSeguroCancelacion();
    }
    
    // Detectar cambios en r_cancel_insurance
    if (prevState.r_cancel_insurance !== this.state.r_cancel_insurance) {
      await this.recalcularSeguroCancelacion();
    }
    
    // Detectar cambios en r_insurance
    if (prevState.r_insurance !== this.state.r_insurance) {
      await this.recalcularSeguroCancelacion();
    }
    
    // Detectar cambios en r_gps
    if (prevState.r_gps !== this.state.r_gps) {
      await this.recalcularSeguroCancelacion();
    }
    
    // CORRECCIÓN: Debug de costos usando Standard Summary
   /* if (this.state.rental && this.state.tourPrices && this.state.gpsPrices && this.state.insurancePrices) {
      debugCostCalculation(this.state, "TourProcessingEnhanced");
    }*/
  }

  // ========================================
  // FUNCIÓN PARA CALCULAR COSTO TOTAL DEL RENTAL
  // ========================================
  
  /**
   * Calcula el valor total del tour una sola vez y lo almacena en currentValueToCharge
   * Esta función se ejecuta solo cuando cambian las opciones del tour
   */
  calcularValorTotalTour = (rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) => {
   
    // 1. Calcular días efectivos
    const effectiveDays = this.duration(rental.effective_start_date, rental.effective_end_date, true);
   
    // 2. Obtener precio base del tour
    const tourBasePrice = this.getTourBasePrice(tourPrices, effectiveDays, models.find(m => m.id === this.state.vehicle_model_1).model_name === "Own Motorcycle");
   
    // 3. Calcular precio del pasajero si existe - CORRECCIÓN: Usar la misma lógica que handleProcessedTourData
    let passengerPrice = 0;
    if (rental.booking && rental.booking.p_first_name && rental.booking.p_first_name.trim() !== "") {
      passengerPrice = this.getPassengerPrice(tourPrices, effectiveDays);
    
    }
    
    // 4. Calcular precio del modelo seleccionado
    const modelPrice = this.getModelPrice(rental.booking.vehicle_model_1, models, tourPrices);
 
    // 5. Calcular precio del GPS - CORRECCIÓN: Usar la misma lógica que handleProcessedTourData
    let gpsPrice = 0;
    if (options.r_gps || (rental.device && rental.device.length > 0)) {
      gpsPrice = this.getGPSPrice(gpsPrices, effectiveDays);
    }
    
    // 6. Calcular precio del seguro VIP - CORRECCIÓN: Usar la misma lógica que handleProcessedTourData
    let vipInsurancePrice = 0;
    if (options.r_insurance || (rental.insurance && rental.insurance.length > 0)) {
      vipInsurancePrice = this.getVIPInsurancePrice(insurancePrices, effectiveDays);
      }
    
    // 7. Calcular precio de habitación individual - CORRECCIÓN: Usar la misma lógica que handleProcessedTourData
    let singlePrice = 0;
    if (options.r_single || (rental.single && rental.single.length > 0)) {
      singlePrice = this.getSinglePrice(tourPrices, effectiveDays);
     }
    
    // 8. Calcular suplementos pendientes
    const pendingSupplements = this.getPendingSupplements(rental);
   
    // 9. Calcular descuentos y recompensas
    const rewards = options.rewards || 0;
    const discount = options.discount || 0;
   
    // 10. Calcular total del tour (SIN descuentos de charges)
    const tourTotal = tourBasePrice + passengerPrice + modelPrice + gpsPrice + vipInsurancePrice + singlePrice + pendingSupplements - rewards - discount;

    return {
      tourTotal,
      effectiveDays,
      breakdown: {
        tourBasePrice,
        passengerPrice,
        modelPrice,
        gpsPrice,
        vipInsurancePrice,
        singlePrice,
        pendingSupplements,
        rewards,
        discount
      }
    };
  };
  
  /**
   * Calcula el value_to_charge basado en el currentValueToCharge y los charges aplicados
   * Esta función se ejecuta cuando cambian los charges o pagos
   */
  calcularValueToCharge = (currentValueToCharge, rental) => {
  
    // Calcular total pagado (charges status 1 + payments)
    let totalPaid = 0;
    
    if (rental.charges && rental.charges.length > 0) {
      const chargesStatus1 = rental.charges.filter(charge => charge.status === 1);
      const totalChargesPaid = chargesStatus1.reduce((sum, charge) => sum + (charge.amount || 0), 0);
      totalPaid += totalChargesPaid;
     
      // Mostrar detalle de charges
      chargesStatus1.forEach((charge, index) => {
       
      });
    }
    
    if (rental.payments && rental.payments.length > 0) {
      const totalPayments = rental.payments.reduce((sum, payment) => sum + (payment.amount || 0), 0);
      totalPaid += totalPayments;
      }
    
  
    // Calcular value to charge (remanente)
    const valueToCharge = currentValueToCharge - totalPaid;

    return {
      valueToCharge,
      totalPaid
    };
  };
  
  calcularCostoTotalRental(rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) {
  
    // 1. Calcular días efectivos
    const effectiveDays = this.duration(rental.effective_start_date, rental.effective_end_date, true);
  
    // 2. Obtener precio base del tour
    const tourBasePrice = this.getTourBasePrice(tourPrices, effectiveDays, models.find(m => m.id === rental.booking.vehicle_model_1).model_name === "Own Motorcycle");
   
    // 3. Calcular precio del pasajero si existe
    let passengerPrice = 0;
    if (rental.booking && rental.booking.p_first_name) {
      passengerPrice = this.getPassengerPrice(tourPrices, effectiveDays);
    }
    
    // 4. Calcular precio del modelo seleccionado
    const modelPrice = this.getModelPrice(rental.booking.vehicle_model_1, models, tourPrices);
   
    // 5. Calcular precio del GPS si está seleccionado
    let gpsPrice = 0;
    if (options.r_gps) {
      gpsPrice = this.getGPSPrice(gpsPrices, effectiveDays);
    }
    
    // 6. Calcular precio del seguro VIP si está seleccionado
    let vipInsurancePrice = 0;
    if (options.r_insurance) {
      vipInsurancePrice = this.getVIPInsurancePrice(insurancePrices, effectiveDays);
    }
    
    // 7. Calcular precio de habitación individual si está seleccionada
    let singlePrice = 0;
    if (options.r_single) {
      singlePrice = this.getSinglePrice(tourPrices, effectiveDays);
    }
    
    // 8. Calcular suplementos pendientes
    const pendingSupplements = this.getPendingSupplements(rental);
   
    // 9. Calcular descuentos y recompensas
    const rewards = options.rewards || 0;
    const discount = options.discount || 0;
  
    // 10. Calcular total del rental
    const rentalTotal = tourBasePrice + passengerPrice + modelPrice + gpsPrice + vipInsurancePrice + singlePrice + pendingSupplements - rewards - discount;
    
   
    
    // 11. Calcular total pagado (charges status 1 + payments)
    let totalPaid = 0;
    
    if (rental.charges && rental.charges.length > 0) {
      const chargesStatus1 = rental.charges.filter(charge => charge.status === 1);
      const totalChargesPaid = chargesStatus1.reduce((sum, charge) => sum + (charge.amount || 0), 0);
      totalPaid += totalChargesPaid;
    
      // Mostrar detalle de charges
      chargesStatus1.forEach((charge, index) => {
      
      });
    }
    
    if (rental.payments && rental.payments.length > 0) {
      const totalPayments = rental.payments.reduce((sum, payment) => sum + (payment.amount || 0), 0);
      totalPaid += totalPayments;
       }
    
  
    // 12. Calcular value to charge (remanente)
    const valueToCharge = rentalTotal - totalPaid;
    
   
    return {
      rentalTotal,
      valueToCharge,
      effectiveDays,
      breakdown: {
        tourBasePrice,
        passengerPrice,
        modelPrice,
        gpsPrice,
        vipInsurancePrice,
        singlePrice,
        pendingSupplements,
        rewards,
        discount,
        totalPaid
      }
    };
  }
  
  // Función auxiliar para obtener precio base del tour
  getTourBasePrice(tourPrices, effectiveDays, isOwnMotorcycle) {
    console.log('isOwnMotorcycle', isOwnMotorcycle);
    if (isOwnMotorcycle) {
      const tourPassengerPriceItem = tourPrices.find(p => p.price_item_sub_type === "tour_passenger");
      const tourPassengerPricePerDay = tourPassengerPriceItem ? tourPassengerPriceItem.price + 500 : 0;
      return tourPassengerPricePerDay ;
    }
    const tourPrice = tourPrices.find(p => p.price_item_sub_type === "tour_total");
    return tourPrice ? tourPrice.price : 0;
  }
  
  // Función auxiliar para obtener precio del pasajero
  getPassengerPrice(tourPrices, effectiveDays) {
    const passengerPrice = tourPrices.find(p => p.price_item_sub_type === "tour_passenger");
    return passengerPrice ? passengerPrice.price * effectiveDays : 0;
  }
  
  // Función auxiliar para obtener precio del modelo
  getModelPrice(vehicleModelId, models, tourPrices) {
    const selectedModel = models.find(m => m.id === vehicleModelId);
    if (!selectedModel) return 0;
    
    const upgradeType = `cat_${selectedModel.vehicle_category_id}`;
    const modelPrice = tourPrices.find(p => p.price_item_sub_type === upgradeType);
    return modelPrice ? modelPrice.price : 0;
  }
  
  // Función auxiliar para obtener precio del GPS
  getGPSPrice(gpsPrices, effectiveDays) {
    const priceList = Array.isArray(gpsPrices)
      ? gpsPrices
      : gpsPrices && Array.isArray(gpsPrices.data)
        ? gpsPrices.data
        : [];

    if (priceList.length === 0) {
      return 0;
    }

    const gpsPrice = priceList.find(p => p.price_item_type === "gps_device");
    const pricePerDay = gpsPrice
      ? parseFloat(gpsPrice.price || gpsPrice.amount || gpsPrice.value || 0)
      : 0;

    if (!pricePerDay) {
      return 0;
    }

    return pricePerDay * effectiveDays;
  }
  
  // Función auxiliar para obtener precio del seguro (Basic/Premium)
  getVIPInsurancePrice(insurancePrices, effectiveDays) {
    const applicableId = resolveApplicableInsuranceId(
      this.state.r_insurance_id,
      effectiveDays
    );
    if (!isPaidInsurance(applicableId) && !this.state.r_insurance) return 0;
    const daily = dailyInsurancePriceFromList(insurancePrices, applicableId);
    return daily * (Number(effectiveDays) || 0);
  }
  
  // Función auxiliar para obtener precio de habitación individual
  getSinglePrice(tourPrices, effectiveDays) {
    const singlePrice = tourPrices.find(p => p.price_item_sub_type === "tour_single");
    return singlePrice ? singlePrice.price : 0;
  }
  
  // Función auxiliar para obtener suplementos pendientes
  getPendingSupplements(rental) {
    if (!rental.supplements || rental.supplements.length === 0) return 0;
    
    const pendingSupplements = rental.supplements.filter(s => s.status === 0);
    return pendingSupplements.reduce((sum, supplement) => sum + (supplement.amount || 0), 0);
  }

  // ========================================
  // FUNCIONES AUXILIARES PARA CÁLCULO DE PRECIOS
  // ========================================

  /**
   * Calcula los días efectivos del tour
   */
  calculateEffectiveDays(rental) {
    if (isNil(rental)) {
      return 0;
    }

    // Extraer fechas efectivas desde booking.tour si existen
    const tourInfo = path(["booking", "tour"], rental) || {};

    const effectiveStart =
      tourInfo.effective_start_date ||
      rental.effective_start_date ||
      tourInfo.tour_start_date;

    const effectiveEnd =
      tourInfo.effective_end_date ||
      rental.effective_end_date ||
      tourInfo.tour_end_date ||
      tourInfo.tour_start_date;

    if (!effectiveStart || !effectiveEnd) {
      return 0;
    }

    const startDate = moment(effectiveStart).utc();
    const endDate = moment(effectiveEnd).utc();

    if (!startDate.isValid() || !endDate.isValid()) {
      return 0;
    }

    const days = this.duration(startDate, endDate, true);

    return days >= 0 ? days : 0;
  }

  /**
   * Obtiene el precio base del tour desde la tabla de precios
   */
  getTourBasePrice(tourPrices, isOwnMotorcycle) {
    console.log('isOwnMotorcycle', isOwnMotorcycle);
    if (isOwnMotorcycle) {
      const tourPassengerPriceItem = tourPrices.find(p => p.price_item_sub_type === "tour_passenger");
      const tourPassengerPricePerDay = tourPassengerPriceItem ? tourPassengerPriceItem.price + 500: 0;
      return tourPassengerPricePerDay ;
    }
    const tourPrice = tourPrices.find(p => p.price_item_sub_type === "tour_total");
    return tourPrice ? tourPrice.price : 0;
  }

  /**
   * Calcula el precio del pasajero si existe
   */
  calculatePassengerPrice(rental, tourPrices, effectiveDays) {
    // Verificar si hay pasajero en el booking o en el objeto passenger
    const hasPassenger = (rental.booking && rental.booking.p_first_name && rental.booking.p_first_name.trim() !== "") ||
                        (rental.passenger && rental.passenger.length > 0);
    
    if (!hasPassenger) {
      return 0;
    }

    const passengerPrice = tourPrices.find(p => p.price_item_sub_type === "tour_passenger");
    return passengerPrice ? passengerPrice.price  : 0;
  }

  /**
   * Calcula el precio del vehículo seleccionado
   */
  calculateVehiclePrice(rental, tourPrices, models) {
    // Para tours procesados, obtener el vehículo desde vehicle o selected_vehicle_from_items
    let vehicleModelId = null;

    if (!isNil(this.state.vehicle_model_1) && this.state.vehicle_model_1 !== 0) {
      vehicleModelId = parseInt(this.state.vehicle_model_1, 10);
    } else if (rental.vehicle && rental.vehicle.length > 0) {
      vehicleModelId = rental.vehicle[0].vehicle_model_id;
    } else if (rental.selected_vehicle_from_items) {
      vehicleModelId = rental.selected_vehicle_from_items.vehicle_model_id;
    } else if (rental.booking && rental.booking.vehicle_model_1) {
      vehicleModelId = rental.booking.vehicle_model_1;
    }

    if (!vehicleModelId) {
      return 0;
    }

    // Buscar el modelo en la lista de modelos
    const selectedModel = models.find(m => m.id === vehicleModelId);
    if (!selectedModel) {
      return 0;
    }

    // Si es "Own Motorcycle", no hay costo adicional
    if (selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    // Buscar el precio del modelo en tourPrices
    const modelPrice = tourPrices.find(p => p.price_item_sub_type === `tour_${selectedModel.upgrade_type}`);
    return modelPrice ? modelPrice.price : 0;
  }

  /**
   * Calcula el precio del vehículo seleccionado
   */
  calculateVehicle2Price(rental, tourPrices, models) {
    // ✅ CORRECCIÓN: Siempre usar vehicle_model_2 del booking como segunda opción
    let vehicleModelId = null;

    if (!isNil(this.state.vehicle_model_2) && this.state.vehicle_model_2 !== 0) {
      vehicleModelId = parseInt(this.state.vehicle_model_2, 10);
    } else if (rental.booking && rental.booking.vehicle_model_2) {
      vehicleModelId = rental.booking.vehicle_model_2;
    }

    if (!vehicleModelId) {
      return 0;
    }

    // Buscar el modelo en la lista de modelos
    const selectedModel = models.find(m => m.id === vehicleModelId);
    if (!selectedModel) {
      return 0;
    }

    // Si es "Own Motorcycle", no hay costo adicional
    if (selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    // Buscar el precio del modelo en tourPrices
    const modelPrice = tourPrices.find(p => p.price_item_sub_type === `tour_${selectedModel.upgrade_type}`);
    return modelPrice ? modelPrice.price : 0;
  }


  /**
   * Calcula el precio del GPS
   */
  calculateGPSPrice(rental, gpsPrices, effectiveDays) {
    let hasGPS = false;

    if (!isNil(this.state.r_gps)) {
      hasGPS = this.state.r_gps;
    } else {
      // Verificar si GPS está activado en booking o si hay device asignado
      hasGPS = (rental.booking && rental.booking.r_gps) || 
               (rental.device && rental.device.length > 0) ||
               (rental.r_gps === true);
    }

    if (!hasGPS) {
      return 0;
    }

    const gpsPrice = gpsPrices.find(p => p.price_item_type === "gps_device");
    return gpsPrice ? gpsPrice.price * effectiveDays : 0;
  }

  /**
   * Calcula el precio del seguro VIP
   */
  calculateVIPInsurancePrice(rental, insurancePrices, effectiveDays) {
    const fromState = this.state.r_insurance_id != null
      ? this.state.r_insurance_id
      : (rental.booking && rental.booking.r_insurance_id != null
        ? rental.booking.r_insurance_id
        : ((rental.insurance && rental.insurance[0] && rental.insurance[0].id)
          || rental.booking.r_insurance));
    const applicableId = resolveApplicableInsuranceId(fromState, effectiveDays);
    if (!isPaidInsurance(applicableId)) return 0;
    const daily = dailyInsurancePriceFromList(insurancePrices, applicableId);
    return daily * (Number(effectiveDays) || 0);
  }

  /**
   * Calcula el precio de habitación individual
   */
  calculateSingleRoomPrice(rental, tourPrices) {
    let hasSingleRoom = false;

    if (!isNil(this.state.r_single)) {
      hasSingleRoom = this.state.r_single;
    } else {
      // Verificar si habitación individual está activada en booking o si hay single en items
      hasSingleRoom = (rental.booking && rental.booking.r_single) ||
                       (rental.single && rental.single.length > 0) ||
                       (rental.r_single === true);
    }

    if (!hasSingleRoom) {
      return 0;
    }

    const singlePrice = tourPrices.find(p => p.price_item_sub_type === "tour_single");
    return singlePrice ? singlePrice.price : 0;
  }

  /**
   * Calcula el seguro de cancelación
   */
  calculateCancelInsurancePrice(rental, insurancePrices, baseAmount) {
    let hasCancelInsurance = false;

    if (!isNil(this.state.r_cancel_insurance)) {
      hasCancelInsurance = this.state.r_cancel_insurance;
    } else {
      // Verificar si seguro de cancelación está activado
      hasCancelInsurance = (rental.booking && rental.booking.r_cancel_insurance) ||
                            (rental.cancel_insurance && rental.cancel_insurance.length > 0) ||
                            (rental.r_cancel_insurance === true);
    }

    if (!hasCancelInsurance) {
      return 0;
    }

    const cancelInsurance = insurancePrices.find(p => p.price_item_type === "insurance" && p.price_item_id === 3);
    if (!cancelInsurance) {
      return 0;
    }

    const percentage = cancelInsurance.percentage || 7.5; // Default 7.5%
    return (baseAmount * percentage) / 100;
  }

  /**
   * Calcula suplementos pendientes desde payments/charges
   */
  calculatePendingSupplements(rental) {
    let total = 0;
   // console.log(rental);
    if (rental.payments && rental.payments.length > 0) {
      rental.payments.forEach(payment => {
        if (payment.charges && payment.charges.length > 0) {
          payment.charges.forEach(charge => {
            if (charge.status === false && charge.extra_charge === true) {
              total += charge.value || 0;
            }
          });
        }
      });
    }
   // console.log('total suplemento', total);
    return total;
  }

  /**
   * Calcula el total pagado desde payments/charges
   */
  calculateTotalPaid(rental) {
    let totalPaid = 0;
    let totalRefunded = 0;

    const isChargePaid = (c) => c.status === true || c.status === 1;
    const isMarkedToRefund = (c) => c.to_refund === true || c.to_refund === 1;

    if (rental.payments && rental.payments.length > 0) {
      rental.payments.forEach(payment => {
        if (payment.charges && payment.charges.length > 0) {
          payment.charges.forEach(charge => {
            if (isChargePaid(charge)) {
              totalPaid += charge.value || 0;
              if (isMarkedToRefund(charge)) {
                totalRefunded += charge.refunded_value || 0;
              }
            }
          });
        }
      });
    }
   // console.log('totalPaid', totalPaid);
   // console.log('totalRefunded', totalRefunded);
    return { totalPaid, totalRefunded };
  }

  /**
   * Calcula el valor total del tour incluyendo todos los componentes
   */
  calculateTotalTourValue(rental, tourPrices, gpsPrices, insurancePrices, models) {
    const effectiveDays = this.calculateEffectiveDays(rental);
    
    // Calcular cada componente
    const tourBasePrice = this.getTourBasePrice(tourPrices, models.find(m => m.id === rental.booking.vehicle_model_1).model_name === "Own Motorcycle");
    const passengerPrice = this.calculatePassengerPrice(rental, tourPrices, effectiveDays);
    const vehiclePrice = this.calculateVehiclePrice(rental, tourPrices, models);
    const gpsPrice = this.calculateGPSPriceWithState(gpsPrices, effectiveDays);
    const vipInsurancePrice = this.calculateVIPInsurancePriceWithState(insurancePrices, effectiveDays);
    const singleRoomPrice = this.calculateSingleRoomPriceWithState(tourPrices);
    const lowSeatPrice = this.calculateLowSeatPriceWithState(tourPrices);
    const pendingSupplements = this.calculatePendingSupplements(rental);
    
    // Calcular base para seguro de cancelación con valores actuales
    const cancelInsuranceBase = tourBasePrice + passengerPrice + vehiclePrice + gpsPrice + singleRoomPrice + lowSeatPrice;
    const cancelInsurancePrice = this.calculateCancelInsurancePriceWithState(insurancePrices, cancelInsuranceBase);
    
    // Calcular descuentos y recompensas usando el estado actual
    const discount = parseFloat(this.state.discount) || 0;
    const rewards = parseFloat(this.state.rewards) || 0;
    
    // Calcular total
    const totalValue = tourBasePrice + passengerPrice + vehiclePrice + gpsPrice + 
                      vipInsurancePrice + singleRoomPrice + cancelInsurancePrice + 
                      lowSeatPrice + pendingSupplements - discount - rewards;
    
    return {
      totalValue,
      effectiveDays,
      breakdown: {
        tourBasePrice,
        passengerPrice,
        vehiclePrice,
        gpsPrice,
        vipInsurancePrice,
        singleRoomPrice,
        cancelInsurancePrice,
        lowSeatPrice,
        pendingSupplements,
        discount,
        rewards
      }
    };
  }

  /**
   * Calcula el valor a cobrar (value to charge) restando pagos realizados
   */
  calculateValueToCharge(rental, totalTourValue) {
   // console.log('totalTourValue', totalTourValue);
    const { totalPaid, totalRefunded } = this.calculateTotalPaid(rental);
   // console.log('totalPaid', totalPaid);
  //  console.log('totalRefunded', totalRefunded);
    const netPaid = (totalPaid || 0) - (totalRefunded || 0);
    const valueToCharge = totalTourValue - netPaid;
  //  console.log('valueToCharge', valueToCharge);
    return {
      valueToCharge: Math.max(0, valueToCharge),
      totalPaid,
      totalRefunded
    };
  }

  // ========================================
  // FUNCIONES AUXILIARES REUTILIZABLES
  // ========================================

  /**
   * Función principal para calcular todos los precios del tour
   * Reemplaza todas las funciones duplicadas anteriores
   */
  calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models) {
    // Calcular valor total del tour
    const tourCalculation = this.calculateTotalTourValue(rental, tourPrices, gpsPrices, insurancePrices, models);
    
    // Calcular valor a cobrar
    const chargeCalculation = this.calculateValueToCharge(rental, tourCalculation.totalValue);
    
    return {
      ...tourCalculation,
      ...chargeCalculation
    };
  }

  /**
   * Función simplificada para compatibilidad con código existente
   */
  calcularValorTotalTour = (rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) => {
    return this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
  };
  
  /**
   * Función simplificada para compatibilidad con código existente
   */
  calcularCostoTotalRental = (rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) => {
    return this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
  };

  /**
   * Función simplificada para compatibilidad con código existente
   */
  calcularRentalTotalCompleto = (rental, tourPrices, gpsPrices, insurancePrices, models, options = {}) => {
    return this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
  };

  // ========================================
  // MÉTODO PARA CALCULAR TODOS LOS PRECIOS UNA SOLA VEZ
  // ========================================

  /**
   * Calcula todos los precios del tour y los guarda en el state para reutilización
   * Este método se ejecuta una sola vez al cargar los datos
   */
  calculateAndStoreAllPricing() {
    const { rental, tourPrices, gpsPrices, insurancePrices, models } = this.state;
    
    if (!rental || !tourPrices || !gpsPrices || !insurancePrices || !models) {
      return;
    }

    try {
      // Usar la función principal de cálculo
      const pricingCalculation = this.calculateAllTourPricing(rental, tourPrices, gpsPrices, insurancePrices, models);
      
      // Calcular precios individuales para mostrar en el UI
      const effectiveDays = this.calculateEffectiveDays(rental);
      const tourBasePrice = this.getTourBasePrice(tourPrices, models.find(m => m.id === rental.booking.vehicle_model_1).model_name === "Own Motorcycle");
      const passengerPrice = this.calculatePassengerPrice(rental, tourPrices, effectiveDays);
      const vehiclePrice = this.calculateVehiclePrice(rental, tourPrices, models);
      const gpsPrice = this.calculateGPSPrice(rental, gpsPrices, effectiveDays);
      const vipInsurancePrice = this.calculateVIPInsurancePrice(rental, insurancePrices, effectiveDays);
      const singlePrice = this.calculateSingleRoomPrice(rental, tourPrices);
      const cancelInsurancePrice = this.calculateCancelInsurancePrice(rental, insurancePrices, tourBasePrice + passengerPrice + vehiclePrice + gpsPrice + singlePrice);
      const pendingSupplements = this.calculatePendingSupplements(rental);
      
      // Calcular precios para modelo 1 y modelo 2
      const model1Price = this.calculateVehiclePrice({ ...rental, booking: { ...rental.booking, vehicle_model_1: rental.booking.vehicle_model_1 } }, tourPrices, models);
      const model2Price = this.calculateVehiclePrice({ ...rental, booking: { ...rental.booking, vehicle_model_1: rental.booking.vehicle_model_2 } }, tourPrices, models);
      
      // Calcular totales para ambos modelos
      const rentalTotal1 = pricingCalculation.totalValue;
      const rentalTotal2 = pricingCalculation.totalValue + (model2Price - model1Price);
      
    //  console.log('rentalTotal1', pricingCalculation.valueToCharge);
      // Actualizar el state con todos los cálculos
      this.setState({
        // Días efectivos
        effectiveDays: pricingCalculation.effectiveDays,
        
        // Precios individuales
        tourBasePrice,
        passengerPrice,
        vehiclePrice,
        gpsPrice,
        vipInsurancePrice,
        singlePrice,
        cancelInsurancePrice,
        pendingSupplements,
        model1Price,
        model2Price,
        
        // Totales
        rentalTotal1,
        rentalTotal2,
        
        // Desglose detallado para el UI
        pricingBreakdown: {
          tour_total: tourBasePrice,
          vehicle_model: vehiclePrice,
          single_room: singlePrice,
          gps_total: gpsPrice,
          vip_insurance: vipInsurancePrice,
          cancel_insurance: cancelInsurancePrice,
          low_seat: 0, // TODO: Implementar si es necesario
          subtotal: pricingCalculation.totalValue,
          final_total: pricingCalculation.valueToCharge
        },
        
        // Valores de cobro
        value_to_charge: pricingCalculation.valueToCharge.toFixed(2),
        valueToChargeConfirmed: pricingCalculation.valueToCharge.toFixed(2),
        currentValueToCharge: pricingCalculation.totalValue,
        
        // Información de pagos
        totalPaid: pricingCalculation.totalPaid,
        totalRefunded: pricingCalculation.totalRefunded,
        
        // Porcentaje de seguro de cancelación
        cancelInsurancePercentage: this.state.cancelInsurancePercentage || 7.5,
        cancelInsuranceValue: cancelInsurancePrice
      });

     /* console.log('✅ Todos los precios calculados y guardados en el state:', {
        effectiveDays: pricingCalculation.effectiveDays,
        totalValue: pricingCalculation.totalValue,
        valueToCharge: pricingCalculation.valueToCharge,
        breakdown: pricingCalculation.breakdown
      });*/

    } catch (error) {
      console.error('❌ Error calculando precios:', error);
    }
  }

  render() {
    // ========================================
    // CORRECCIÓN DEL RENDER
    // ========================================
  
    // Calcular y mostrar First Choice Total
    const firstChoiceTotal = (this.state.tourTotal || 0) + (this.state.model1Price || 0) + (this.state.passengerPrice || 0) + (this.state.gpsPrice || 0) + (this.state.vipInsurancePrice || 0);
  
    // Calcular y mostrar Second Choice Total
    const secondChoiceTotal = (this.state.tourTotal || 0) + (this.state.model2Price || 0) + (this.state.passengerPrice || 0) + (this.state.gpsPrice || 0) + (this.state.vipInsurancePrice || 0);
   

    const { loading, error, rental, isPendingTour } = this.state;

    if (loading) {
      return (
        <Card>
          <CardContent>
            <LinearProgress />
            <Typography variant="h6" style={{ textAlign: "center", marginTop: 16 }}>
              Loading tour data...
            </Typography>
          </CardContent>
        </Card>
      );
    }

    if (error) {
      return (
        <Card>
          <CardContent>
            <CustomAlert className="error">
              <Typography variant="h6">Error</Typography>
              <Typography>{error}</Typography>
            </CustomAlert>
          </CardContent>
        </Card>
      );
    }

    if (!rental) {
      return (
        <Card>
          <CardContent>
            <CustomAlert className="warning">
              <Typography>No tour data available</Typography>
            </CustomAlert>
          </CardContent>
        </Card>
      );
    }

    if (!rental.booking) {
      return (
        <Card>
          <CardContent>
            <CustomAlert className="warning">
              <Typography>No tour data available or booking information is missing</Typography>
            </CustomAlert>
          </CardContent>
        </Card>
      );
    }

    return (
      <React.Fragment>
      <MainContainer>
        <LeftPanel>
          <CardContent>
            <Typography variant="h4" gutterBottom style={{ color: "#000000", marginBottom: 24 }}>
              {isPendingTour ? "Processing Tour Booking" : "Editing Tour Booking"} For:{" "}
              <b>{rental.booking.r_first_name} {rental.booking.r_last_name}</b>
              <ProfileCompleteMark record={rental} size={28} />
            </Typography>
            
            {/* Mostrar indicador de estado */}
           {/*  <div style={{ marginBottom: 16 }}>
              {isPendingTour ? (
                <Chip 
                  icon={<WarningIcon />} 
                  label="Pending Processing" 
                  color="warning" 
                  variant="outlined"
                />
              ) : (
                <Chip 
                  icon={<CheckCircleIcon />} 
                  label="Already Processed" 
                  color="success" 
                  variant="outlined"
                />
              )}
            </div> */}
            
            <TwoColumnLayout>
              <Column>
                {this.renderOptionsSection()}
                {this.renderVehicleSection()}
                {this.renderAdditionalFields()}
              </Column>
              
              <Column>
                {this.renderPricingSection()}
                {this.renderActions()}
              </Column>
            </TwoColumnLayout>
          </CardContent>
        </LeftPanel>
        
        <RightPanel>
          <CardContent>
            {this.renderSummarySection()}
          </CardContent>
        </RightPanel>
              </MainContainer>
        <ClientDocumentsModal
          open={this.state.clientDocumentsModalOpen}
          onClose={() => this.setState({ clientDocumentsModalOpen: false })}
          clientId={documentTarget(this.state.rental).clientId}
          rentalId={documentTarget(this.state.rental).rentalId}
        />
      </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => ({
  state: state,
});

const mapDispatchToProps = {
  showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(TourProcessingEnhanced); 


// WEBPACK FOOTER //
// ./src/components/tour/TourProcessingEnhanced.js